import { Component, OnInit, ViewChild, ElementRef, HostListener, ChangeDetectorRef, Input, EventEmitter, Output } from '@angular/core';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { NavigationExtras } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { File } from '@ionic-native/file/ngx';
import { ModalController, NavController } from '@ionic/angular';
import { SwiperContainer } from 'swiper/element';
import { Storage } from '@ionic/storage-angular';
import { DetailProjectService } from 'src/app/services/detail-project.service';
import { PortfolioService } from 'src/app/services/portfolio.service';
import { ListOfProjectsService } from 'src/app/services/list-of-projects.service';
import { OverviewProjectService } from 'src/app/services/overview-project.service';
import { AuthService } from 'src/app/services/auth.service';
import { CommunicationService } from 'src/app/services/communication.service';
import { DataLayerService } from 'src/app/services/data-layer.service';
import { HelpService } from 'src/app/services/help.service';
import { InvestCardService } from 'src/app/services/invest-card.service';
import { OffersService } from 'src/app/services/offers.service';
import { ProfileService } from 'src/app/services/profile.service';
import { UtilsService } from 'src/app/services/utils.service';
import { Benefit, BenefitProject, BenefitsByMonth } from 'src/app/shared/models/benefits.models';
import { MarketPlaceBidCreateModel, MarketPlaceOfferCreateModel, MarketPlaceOfferModel, MarketPlaceMyOffersModel, MarketPlaceProjectModel } from 'src/app/shared/models/marketplace.models';
import { environment } from 'src/environments/environment';
import { AlertService } from '../../alert/alert.service';
import { DocumentationListComponent } from '../../documentation-list/documentation-list.component';
import { ProjectDetailComponent } from '../../marketplace/project-detail/project-detail.component';
import { ModalService } from '../../modal/modal.service';
import { ToastService } from '../../toast/toast.service';
import { UpdateListComponent } from '../../update-list/update-list.component';
import { TranslateService } from '@ngx-translate/core';
import { SkeletonListComponent } from '../../skeleton/skeleton-list.component';
import { OveralMessageComponent } from '../../overal-message/overal-message.component';
import { InvestComponent } from '../../invest/invest.component';
import { WarningComponent } from '../../warning/warning.component';
import { InvestReservedComponent } from '../../invest/invest-reserved/invest-reserved.component';
import { InvestTestConvenienceComponent } from '../../invest/invest-test-convenience/invest-test-convenience.component';
import { BidCreateComponent } from '../../marketplace/bid-create/bid-create.component';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { Location } from '@angular/common';
import * as momentNs from 'moment';
import { AffiliationLocalInvestComponent } from '../../affiliation-local-invest/affiliation-local-invest.component';
import { PageSubmenuComponent } from '../../page-submenu/page-submenu.component';
import { SubscribeProjectNewsComponent } from '../../subscribe-project-news/subscribe-project-news.component';
import { HubspotService } from 'src/app/services/hubspot.service';
import { RenewSessionComponent } from '../../renew-session/renew-session.component';
import { BiometricService } from 'src/app/services/biometric.service';
import { DailyProductionGraphicService } from '../../daily-production-graphic/daily-production-graphic.service';
import { IncomeGraphicService } from '../../income-graphic/income-graphic.service';
import { ProductionGraphicService } from '../../production-graphic/production-graphic.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { StrapiService } from 'src/app/services/strapi.service';
import { InvestFinishSignComponent } from '../../invest/invest-finish-sign/invest-finish-sign.component';
import { PosthogService } from 'src/app/services/posthog.service';
import { Browser } from '@capacitor/browser';
import { Platform } from '@ionic/angular';
import { MangopayScaValidationComponent } from '../../mangopay-sca-validation/mangopay-sca-validation.component';

const moment = momentNs;

@Component({
  selector: 'fun-new-detail-overview',
  templateUrl: './new-detail-overview.component.html',
  styleUrls: ['./new-detail-overview.component.scss'],
  providers: [File]
})
export class NewDetailOverviewComponent implements OnInit {

  // @ViewChild('about', { static: false }) about: ElementRef;
  @ViewChild('investors', { static: false }) investors: ElementRef;
  @ViewChild('consumer', { static: false }) consumer: ElementRef;
  @ViewChild('teamB', { static: false }) teamB: ElementRef;
  @ViewChild('teamM', { static: false }) teamM: ElementRef;
  @ViewChild('doc', { static: false }) doc: ElementRef;
  @ViewChild('map', { static: false }) map: ElementRef;
  @ViewChild('update', { static: false }) update: UpdateListComponent;
  @ViewChild('marketplaceRow', { static: false }) marketplaceRow: ProjectDetailComponent;
  @ViewChild('documentation', { static: false }) documentation: DocumentationListComponent;
  @ViewChild('summary', { static: false }) summary: ElementRef;
  @ViewChild('pageSubmenu', { static: false }) pageSubmenu: PageSubmenuComponent;
  @ViewChild('calculator', { static: false }) calculatorComponet: ElementRef;
  // @ViewChild('content', { static: false }) content: ElementRef;
  @ViewChild('headerSlider') headerSlider: ElementRef<SwiperContainer>;

  @Output() private closeModalEvent = new EventEmitter<void>();
  @Input() slug: any;
  @Input() public page = 'overview';
  @Input() public openProjectInvestmentProccess = false;

  public currentPage: string;
  isUserInvestor: any;
  id: any;
  project: any;
  isWalletOk: boolean;
  lastScrollTop = 0;
  hasScroll = false;
  iosNativeApp: boolean;
  isLoaded = false;
  hasDocuments = false;
  hasStatusaside = false;
  hasConsumer = false;
  headerInfo: any;
  aboutProjectInfo: any;
  investorsInfo: any;
  consumerInfo: any;
  constructorInfo: any;
  managementInfo: any;
  documents: any;
  statusAside: any;
  headerOffsetMenu: string;
  priceCapital: number;
  isInvestor = true;
  changeHeader = true;
  filter;
  typePay;
  nameUser;
  cuopon;

  elementList = [];

  lat: any;
  lon: any;
  mapText: any;
  zoom: any;

  projectMarketp: MarketPlaceProjectModel;
  hasMarketplace: boolean;
  public urlsRoute = ['list-of-projects', 'dashboard'];
  public urlService = 'apiservices/marketplace/v1/marketplace';

  loadedUpdates = false;
  updates: any;
  hasupdates: boolean;
  realUpdates: any;
  space: number;

  aboutSection: boolean;
  promoterSection: boolean;
  managerSection: boolean;

  profile$: any;
  detailProject: any;
  profile: any;
  available: boolean;
  alreadyInvested: any;
  investId: any;
  pendingInvestCall = false;
  currentInvestComponentRef: InvestComponent | null = null;
  refCode: string
  statusP: string;
  canceledIds = [];
  finishedInvest = false;
  transactionId: any;
  public amount: any;
  public currentAmount: any;
  public isCreated = false;
  public activateInvest = environment.activateInvest;
  public activateMarketplace = environment.activateMarketplace;

  public positionIds = [];

  listOfFilter = [];
  defaultItemSelected = this.translate.instant('UPDATES.DATE');

  infoData: any;
  investPostalCodeStepsInfo: any;
  loadingMkp = false;
  pendingPromos = [];
  cancelableInvests = [];
  investmentsPendingSign = [];

  investProjectDocuments: any;
  benefitsByMonth: BenefitsByMonth[] = [];

  moneyToday: any;
  moneyEstimated: any;
  productionToday: any;
  productionEstimated: any;
  moneyAnnual: any;
  moneyAnnualEstimated: any;
  productionHistoric: any;
  moneyHistoric: any;
  lastUpdates: any;
  lastUpdate: any;
  contractSummary: string;
  hasContractSummary: boolean;

  currentDate: any;
  currentMonth: any;
  currentYear: any;
  public currentFilter = 'year';
  public startDate = '2024-01-01';
  public endDate = '2024-12-31';
  listOfYears = [];

  isCnmUser = false;
  openedFromReadMore = false;
  walletStatus = -1;

  pageList = [];

  contributed_intention: number;
  user: any;
  checkedNoHasMonitoring = false;
  refreshModalOpened = false;

  secondaryDocsLits = [];
  loadingFiles = true;
  hasHubspotProducts = false;
  projectDeal: any;
  updatingDeal = false;
  createdDealThisSession: string | null = null;

  annualIncomeList: any;
  loadedAnnualIncomes = false;

  dailyIncomeList: any;
  loadedDailyIncomeList = false;

  dailyProductionList: any;
  hasDailyProductionList = false;
  productionListChecked = false;
  isFlexibleCompensation = false;
  meetingList = [];

  navSlideOpts = {
    initialSlide: 0,
    speed: 1000,
    effect: 'slide',
    slidesPerView: 'auto',
    grabCursor: false,
    slideToClickedSlide: true,
    centeredSlides: false,
    observer: true, // los ion-slide se muestran/ocultan con *ngIf según van cargando headerInfo/detailProject
    slidesOffsetAfter: 40, // hueco tras la última pestaña (no cuenta como parada navegable, a diferencia de un slide falso)
  };
  reserved: number;
  isHubspodDealOkInCurrentInvest: boolean = false;
  vinculatinUserList = [];
  associatedProjectData: any;
  associatedDataShowed = false;
  associatedCompany: string;

  isIOS: boolean;
  contributedInfo: any;
  prevInvestments: [] = [];
  canChangeStage: boolean = true;

  constructor(
    private overviewService: OverviewProjectService,
    public translate: TranslateService,
    private localize: LocalizeRouterService,
    private navCtrl: NavController,
    private communicationService: CommunicationService,
    private modalService: ModalService,
    private utilsService: UtilsService,
    private offersService: OffersService,
    public location: Location,
    private storage: Storage,
    private authService: AuthService,
    private dataLayerService: DataLayerService,
    private toastService: ToastService,
    private listProjectsService: ListOfProjectsService,
    private title: Title,
    private meta: Meta,
    private profileService: ProfileService,
    private investCardService: InvestCardService,
    private utils: UtilsService,
    private alertService: AlertService,
    public chdRef: ChangeDetectorRef,
    private portfolioService: PortfolioService,
    private detailProjectService: DetailProjectService,
    private helpService: HelpService,
    private modalController: ModalController,
    private posthogService: PosthogService,
    private HubspotService: HubspotService,
    private biometricService: BiometricService,
    private dailyProductionservice: DailyProductionGraphicService,
    private incomeService: IncomeGraphicService,
    private productionGraphicService: ProductionGraphicService,
    private http: HttpClient,
    private strapiService: StrapiService,
    private sanitizer: DomSanitizer,
    private platform: Platform,
  ) {
    this.isIOS = this.platform.is('ios');
  }

  ngOnInit() {
    this.initPage();
    // Ionic reuses (no destruye) esta página al navegar a "mis ofertas"/"mis pujas" para gestionar una
    // oferta o puja propia; sin esto, al volver el tablón de anuncios se queda con datos desactualizados.
    this.offersService.cancelOf.subscribe(() => {
      this.getMarketPlaceOffers();
    });
    this.offersService.acceptBid.subscribe(() => {
      this.getMarketPlaceOffers();
    });
  }

  initPage() {
    this.isLoaded = false;
    this.isFlexibleCompensation = false;
    this.hasStatusaside = false;
    this.investmentsPendingSign = [];
    this.prevInvestments = [];
    this.getUserdata();
    this.startToLoadProject();
    this.iosNativeApp = Capacitor.getPlatform() === 'ios' ? true : false;
    this.storage.get('USERNAME').then((val) => {
      if (val === 'fundeen.cnmv@gmail.com') {
        this.isCnmUser = true;
      } else {
        Promise.all([
          this.storage.get('HS_CONTACT_ID'),
          this.storage.get('HS_CONTACT_EMAIL')
        ]).then(([idhbp, contactEmail]) => {
          //console.log('[HubSpot] startToLoadProject → USERNAME:', val, '| HS_CONTACT_ID:', idhbp, '| HS_CONTACT_EMAIL:', contactEmail);
          if (!idhbp || contactEmail !== val) {
            //console.log('[HubSpot] startToLoadProject → contacto no válido para este usuario, buscando en HubSpot...');
            this.HubspotService.searchContact(val).subscribe((resHusbpot: any) => {
              if (resHusbpot.success) {
                const contacts = resHusbpot.data.results;
                if (contacts?.length) {
                  //console.log('[HubSpot] startToLoadProject → contacto encontrado. HS_CONTACT_ID:', contacts[0].id);
                  this.storage.set('HS_CONTACT_ID', contacts[0].id);
                  this.storage.set('HS_CONTACT_EMAIL', val);
                }
              }
            });
          } else {
            //console.log('[HubSpot] startToLoadProject → HS_CONTACT_ID ya válido para', val);
          }
        });
      }
    });

    this.translate.onLangChange.subscribe(event => {
      this.parseContractSummary();
      this.elementList = [];
      this.chdRef.detectChanges();
    });
  }

  nextSliderHeader() {
    this.headerSlider.nativeElement.swiper.slideNext();
    this.chdRef.detectChanges();
  }

  prevSliderHeader() {
    this.headerSlider.nativeElement.swiper.slidePrev();
    this.chdRef.detectChanges();
  }

  async getUserdata() {
    await this.profileService.getUserData().subscribe(user => {
      if (user.blocked) {
        this.authService.logout();
      }
      this.user = user;
    });
  }

  startToLoadProject() {
    this.listOfFilter = [];
    this.elementList = [];
    this.isLoaded = false;
    if (isNaN(Number(this.slug))) {
      this.overviewService.getProjectDetailBySlug(this.slug).subscribe(proj => {
        this.operate(proj);
      });
    } else {
      this.overviewService.getProjectDetail(this.slug).subscribe(proj => {
        if (proj.status < 3) {
          this.navCtrl.navigateRoot([this.localize.translateRoute('/list-of-projects')]);
        } else {
          this.operate(proj);
        }
      });
    }
    this.storage.get('USERDATA').then((val) => {
      if (val.mailVerified === false) {
        this.profileService.verificationMailAdvice();
      }
    });
    this.overviewService.getPendingPromos().subscribe(resp => {
      this.pendingPromos = resp;
      this.chdRef.detectChanges;
    });
  }

  capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  operate(project) {
    this.id = project.id;
    const flexibleCompensationIdStrings = this.translate.instant('RIC_ENERGY.IDS');
    const flexibleCompensationIdsArray = flexibleCompensationIdStrings.split(',').map(Number);
    this.isFlexibleCompensation = flexibleCompensationIdsArray.includes(this.id) && environment.enableRicenergyPortfolio ? true : false;
    if (project.id === 162) {
      project['total'] = project['total'] + 93000; // project['term'] = '2-50';
    }
    this.detailProject = project;
    const projectListWithEmployeeAndClientInvestmentPhase = environment.projectListWithEmployeeAndClientInvestmentPhase;
    const currentProjectHasEmployeeAndClientInvestmentPhase = projectListWithEmployeeAndClientInvestmentPhase.find(proj => proj.projectId === this.detailProject.id);
    if (currentProjectHasEmployeeAndClientInvestmentPhase) {
      this.overviewService.getProjectDetailBySlug(currentProjectHasEmployeeAndClientInvestmentPhase['associatedProject']).subscribe(proj => {
        //this.operate(proj);
        this.associatedProjectData = proj;
        this.associatedCompany = currentProjectHasEmployeeAndClientInvestmentPhase['associatedCompany'];
      });
    }
    const lan = this.capitalizeFirstLetter(this.translate.currentLang);
    const youtubeUrlRaw = this.detailProject[`youtubeUrl${lan}`] ||
      this.detailProject[`youtubeUrlEs`] ||
      this.detailProject[`youtubeUrl`];
    if (youtubeUrlRaw) {
      // Extraer ID del video
      const videoId = this.extractYouTubeId(youtubeUrlRaw);

      if (videoId) {
        this.detailProject.videoId = videoId;

        // Si NO es iOS, configurar iframe
        //if (!this.isIOS) {
        const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}`;
        const params = new URLSearchParams({
          playsinline: '1',
          controls: '1',
          modestbranding: '1',
          rel: '0'
        });

        this.detailProject.youtubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          `${embedUrl}?${params.toString()}`
        );
        //}
      }
    }

    const status = project.status;
    if (status === 12 || status === 4 || status === 14 || status === 15) {
      this.statusP = 'En Financiación';
    } else if (status === 2 || status === 3) {
      this.statusP = 'Futuros';
    } else {
      this.statusP = 'Financiados';
    }
    if (this.detailProject.status === 3
      || this.detailProject.status === 4 || this.detailProject.status === 12 || this.detailProject.status === 14 || this.detailProject.status === 15) {
      this.setAvailable();
    }

    if (this.detailProject && this.detailProject.type === 1) {
      this.headerInfo = {
        hasMarketplace: true,
        hasUpdates: true,
        hasDocumentation: true,
        hasCalendar: true,
        hasMonitoring: true,
        hasMeetingList: true
      };
      this.pageList = [
        {
          icon: 'briefcase',
          title: this.translate.instant('OVERVIEW.SUMMARY'),
          subtitle: this.translate.instant('OVERVIEW.SUMMARY_SUBTITLE'),
          id: 'overview',
          border: true
        },
        {
          icon: 'clock',
          title: this.translate.instant('UPDATES.UPDATES'),
          subtitle: this.translate.instant('LIST_OF_PROJECTS.VIEW_NEWS'),
          id: 'news',
          border: true
        },
        {
          icon: 'file',
          title: this.translate.instant('MOVEMENTS.NOTICEBOARD'),
          subtitle: this.translate.instant('LIST_OF_PROJECTS.MKP_LIST'),
          id: 'marketplace',
          border: true
        },
        {
          icon: 'paperclip',
          title: 'Docs',
          subtitle: this.translate.instant('DOCUMENTATION.SEE_DOCUMENTATION'),
          id: 'documentation',
          border: true
        },
        {
          icon: 'coin-stack',
          title: this.translate.instant('MEETING.TITLE'),
          subtitle: this.translate.instant('MEETING.TITLE'),
          id: 'meeting',
          border: true
        }
      ];
      if (this.detailProject.id !== 38 && this.detailProject.status !== 9) {
        this.pageList.push(
          {
            icon: 'calendar',
            title: this.translate.instant('OVERVIEW.PAY'),
            subtitle: this.translate.instant('OVERVIEW.VIEW_PAY'),
            id: 'calendar',
            border: true
          },
          {
            icon: 'bar-char-2',
            title: this.translate.instant('OVERVIEW.METRICS'),
            subtitle: this.translate.instant('OVERVIEW.VIEW_METRICS'),
            id: 'monitoring',
            border: true
          },
        );
      }
    } else {
      this.headerInfo = {
        hasMarketplace: true,
        hasUpdates: true,
        hasDocumentation: true,
        hasCalendar: true,
        hasMonitoring: false,
        hasMeetingList: false
      };
      this.pageList = [
        {
          icon: 'briefcase',
          title: this.translate.instant('OVERVIEW.SUMMARY'),
          subtitle: this.translate.instant('OVERVIEW.SUMMARY_SUBTITLE'),
          id: 'overview',
          border: true
        },
        {
          icon: 'clock',
          title: this.translate.instant('UPDATES.UPDATES'),
          subtitle: this.translate.instant('LIST_OF_PROJECTS.VIEW_NEWS'),
          id: 'news',
          border: true
        },
        {
          icon: 'paperclip',
          title: 'Docs',
          subtitle: this.translate.instant('DOCUMENTATION.OVERVIEW_SUBTITLE'),
          id: 'documentation',
          border: true
        }
      ];
      if (this.detailProject.status !== 9) {
        this.pageList.push(
          {
            icon: 'file',
            title: this.translate.instant('MOVEMENTS.NOTICEBOARD'),
            subtitle: this.translate.instant('LIST_OF_PROJECTS.MKP_LIST'),
            id: 'marketplace',
            border: true
          },
          {
            icon: 'calendar',
            title: this.translate.instant('OVERVIEW.PAY'),
            subtitle: this.translate.instant('OVERVIEW.VIEW_PAY'),
            id: 'calendar',
            border: true
          },
        );
      }
    }
    // las pestañas del headerSlider se añaden/quitan aquí mismo vía *ngIf (headerInfo/detailProject);
    // sin este recálculo Swiper puede quedarse con anchos de slide obsoletos (medidos antes de que
    // Angular termine de pintar las pestañas) y el salto de "siguiente" avanza mal.
    setTimeout(() => {
      this.headerSlider?.nativeElement?.swiper?.update();
    });
    this.seeSpace();
    this.getProfile();
    this.getWalletType();
    this.filter = 'open';
    this.currentPage = this.page; // 'overview'
    //this.changeHuspotStage('view')
    this.posthogService.pushEventParams('project_view_opened', {
      project_name: this.detailProject.name,
      project_id: this.detailProject.id,
      status: this.detailProject.status
    });
    this.dataLayerService.pushEcomEventGTM('view_item', {
      'currency': 'EUR',
      'items': [{
        'item_id': this.detailProject.id,
        'item_name': this.detailProject.name,
        'price': 500,
        'quantity': 1
      }]
    });
    this.overviewService.currentPage = 'overview';
    this.storage.set('OVERVIEWPAGE', this.currentPage);
    this.getProjectMarketplace(this.id, 'overview');

    this.storage.get('ISINVESTOR').then((val) => {
      this.isUserInvestor = val;
    });
    this.listProjectsService.getProjectsList().subscribe(resp => {
      resp.forEach(element => {
        this.positionIds.push(element.id);
      });
    });

    // Obtenemos nombre y apellidos del profile
    this.storage.get('HS_SURNAME_USER').then((name) => {
      if (name === '' || name === null) {
        this.profile$.subscribe((resp) => {
          this.profile = resp;
          this.storage.set('HS_SURNAME_USER', `${this.profile.name} ${this.profile.surname}`);
        });
      }
    });

    // Obtenemos id del producto de Husbpot
    if (!this.hasHubspotProducts) {
      this.HubspotService.searchProduct(this.id).subscribe((resHusbpot: any) => {
        if (resHusbpot.success) {
          const products = resHusbpot.data.results;
          if (products) {
            this.storage.set('HS_PRODUCT_ID', products[0].id);
          }
          this.hasHubspotProducts = true;
        }
      });
    }

    this.storage.get('USERNAME').then((val) => {
      const projectListWithEmployeeAndClientInvestmentPhase = environment.projectListWithEmployeeAndClientInvestmentPhase;
      const currentProjectHasEmployeeAndClientInvestmentPhase = projectListWithEmployeeAndClientInvestmentPhase.find(project => project.projectId === this.detailProject['id']);
      if (currentProjectHasEmployeeAndClientInvestmentPhase) {
        const model = {
          id: this.detailProject['id'],
          username: val
        };
        this.strapiService.getVinculationList(model).subscribe(resp => {
          if (resp.data && resp.data.length > 0) {
            const list = resp.data;
            this.vinculatinUserList = list;
            const hasInvestmentValidated = list.some(
              (item: any) =>
                item.attributes.status === "validado" &&
                item.attributes.step === "invest"
            );

            if (hasInvestmentValidated) {
              setTimeout(() => {
                this.changeDataToAssociatedProjectInfo();
              }, 1200);
            }
          }
        });
      }
    });

    this.detailProject['show_priority_groups_timeline'] = false;
    if (this.detailProject['priority_groups'] || this.detailProject['postal_code_investment_stages']) {
      this.detailProject['show_priority_groups_timeline'] = (this.detailProject['priority_groups']) ? true : false;
      if (this.detailProject['postal_code_investment_stages']) {
        this.detailProject['postal_code_investment_stages'].sort((a, b) => {
          return new Date(this.convertToIos(momentNs(a.start_date).format('YYYY-MM-DD HH:mm:ss'))).getTime()
            - new Date(this.convertToIos(momentNs(b.start_date).format('YYYY-MM-DD HH:mm:ss'))).getTime();
        });
        this.detailProject['is_consolidation_date'] = this.detailProject['postal_code_investment_stages'].some((stage: any) => {
          const { start_consolidation_date, start_date } = stage;
          if (!start_consolidation_date || !start_date) return false;
          const now = new Date();
          const consolidationDate = new Date(this.convertToIos(momentNs(start_consolidation_date).format('YYYY-MM-DD HH:mm:ss')));
          const stageDate = new Date(this.convertToIos(momentNs(start_date).format('YYYY-MM-DD HH:mm:ss')));
          return now >= consolidationDate && now < stageDate;
        });
      }
      if (this.detailProject['priority_groups']) {
        this.detailProject['priority_groups'] = this.detailProject['priority_groups'].map((pg: any) => ({
          ...pg,
          isGroupObjetiveFull: (pg.investObjective != null && pg.contributedAmount != null) ? pg.contributedAmount >= pg.investObjective : false,
        }));
        this.detailProject['priority_groups'].sort((a, b) => {
          return a.priority - b.priority;
        });
      }
      if (this.detailProject['postal_code_investment_stages'] && this.detailProject['postal_code_investment_stages'].length > 0) {
        for (let i = 0; i < this.detailProject['postal_code_investment_stages'].length; i++) {
          if (this.detailProject['postal_code_investment_stages'][i]['type'] === 2) {
            this.detailProject['postal_code_investment_stages'][i]['priority_groups'] = this.detailProject['priority_groups'];
            this.detailProject['postal_code_investment_stages'][i]['highestUserPriority'] = this.getHighestUserPriority(this.detailProject['priority_groups']);
          }
        }
      }
    }
  }

  private getHighestUserPriority(priorityGroups: any[]): number | null {
    if (!priorityGroups || priorityGroups.length === 0) return null;

    const userGroups = priorityGroups.filter((pg: any) => pg.isEnabledForUser);
    const availableGroups = userGroups.filter((pg: any) => !pg.isGroupObjetiveFull);

    if (userGroups.length > 0) {
      let userAllGroups = '';
      let priorityGroup = null;

      if (userGroups?.length) {
        userAllGroups = userGroups
          .map((pg: any) => 'G' + pg.priority)
          .join('-');

        priorityGroup = userGroups.reduce(
          (prev: any, current: any) =>
            current.priority < prev.priority ? current : prev
        );
      }
      this.detailProject['userGroups'] = userAllGroups;
      this.detailProject['highestUserGroup'] = priorityGroup;
    }

    if (availableGroups.length > 0) {
      return Math.min.apply(null, availableGroups.map((pg: any) => pg.priority));
    }
    if (userGroups.length > 0) {
      return Math.min.apply(null, userGroups.map((pg: any) => pg.priority));
    }
    return null;
  }

  // Extraer ID de cualquier formato de URL de YouTube
  private extractYouTubeId(url: string): string | null {
    if (!url) return null;

    // /embed/VIDEO_ID
    const embedMatch = url.match(/\/embed\/([a-zA-Z0-9_-]+)/);
    if (embedMatch) return embedMatch[1];

    // ?v=VIDEO_ID
    const vMatch = url.match(/[?&]v=([a-zA-Z0-9_-]+)/);
    if (vMatch) return vMatch[1];

    // youtu.be/VIDEO_ID
    const shortMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (shortMatch) return shortMatch[1];

    return null;
  }

  // Abrir video en navegador/app de YouTube (solo iOS)
  async openYouTubeVideo() {
    if (!this.detailProject.videoId) return;

    try {
      await Browser.open({
        url: `https://www.youtube.com/watch?v=${this.detailProject.videoId}`,
        presentationStyle: 'popover'
      });
    } catch (error) {
      console.error('Error abriendo video:', error);
      // Fallback: abrir en nueva pestaña
      window.open(`https://www.youtube.com/watch?v=${this.detailProject.videoId}`, '_blank');
    }
  }

  getWalletType() {
    this.storage.get('WALLET').then((val) => {
      if (val && val !== null && val !== undefined) {
        if (val.refCode && val.refCode !== null && val.refCode !== undefined) {
          this.refCode = val.refCode;
        }
      }
      if (val !== null && val !== undefined && (val.walletstatus === 0 || val.walletstatus === -1)) {
        this.isWalletOk = true;
        this.walletStatus = val.walletstatus;
      } else {
        this.overviewService.getWalletStatus().subscribe(
          (resp) => {
            this.walletStatus = resp.walletStatus;
            if (resp.walletstatus === 0 || resp.walletstatus === -1) {
              this.isWalletOk = true;
            } else {
              this.isWalletOk = false;
            }
            this.chdRef.detectChanges();
          },
          (error) => {
            this.chdRef.detectChanges();
            this.isWalletOk = false;
            this.walletStatus = null;
          }
        );
      }
    });
  }
  @HostListener('window:resize', ['$event']) onResize(event) {
    this.seeSpace();
  }
  seeSpace() {
    if (window.innerWidth > 992) {
      this.space = 60;
    } else {
      this.space = 10;
    }
  }
  async setAvailable() {
    if (this.detailProject.status === 15) {
      this.overviewService.getReservationAvailable(this.id).subscribe(
        (resp) => {
          this.available = true;
          this.chdRef.detectChanges();
        },
        (error) => {
          this.available = false;
          this.chdRef.detectChanges();
        }
      );
    } else {
      this.overviewService.getInvestAvailable(this.id).subscribe(
        (resp) => {
          this.available = true;
          this.chdRef.detectChanges();
        },
        (error) => {
          this.available = false;
          this.chdRef.detectChanges();
        }
      );
    }
  }
  setPriceCapital() {
    return this.priceCapital;
  }
  async getProfile() {
    this.storage.get('USERNAME').then((val) => {
      this.profile$ = this.profileService.getProfile(val);
    });
  }
  async getProjectMarketplace(id, page) {
    const marketplace$ = this.overviewService.getMarketplaceInfo();
    const myOffers$ = this.communicationService.get('apiservices/marketplace/v1/marketplace/offers', null).pipe(
      catchError(() => of([]))
    );
    forkJoin([marketplace$, myOffers$]).subscribe(
      ([resp, myOffers]: [any[], any[]]) => {
        const myOfferIds = new Set((myOffers || []).map((o: any) => o.id));
        let i = 0;
        resp.forEach((element) => {
          const idP = parseInt(this.id);
          if (element.id === idP) {
            this.hasMarketplace = true;
            if (element.offers) {
              element.offers.forEach((offer: MarketPlaceOfferModel) => {
                offer.is_own_offer = myOfferIds.has(offer.id);
              });
            }
            this.projectMarketp = element;
          } else {
            i++;
          }
        });
        if (i === resp.length) {
          this.priceCapital = undefined;
          this.setPriceCapital();
          this.hasMarketplace = false;
        } else {
          this.priceCapital = this.projectMarketp.price_capital;
          this.setPriceCapital();
          this.hasMarketplace = true;
        }
        this.getFullProject(id, page, this.hasMarketplace);
        this.chdRef.detectChanges();
      },
      (error) => {
        this.hasMarketplace = false;
        this.getFullProject(id, page, this.hasMarketplace);
        this.chdRef.detectChanges();
      }
    );
  }
  getFullProject(id, page, hasMp) {
    const projectLan = (this.detailProject.locale !== null && this.detailProject.locale !== undefined) ? this.getInfoTextLan(this.detailProject.locale) : undefined;
    if (projectLan) {
      this.setTitleMeta(projectLan.title, projectLan.metatitle);
    }
    if (this.detailProject.status === 12 || this.detailProject.status === 4 || this.detailProject.status === 14 || this.detailProject.status === 15) {
      this.statusP = 'En Financiación';
      this.getPostCodeAvailable();
    } else if (this.detailProject.status === 2 || this.detailProject.status === 3) {
      this.statusP = 'En Estudio';
      this.getPostCodeAvailable();
    } else {
      this.statusP = 'Financiado';
    }
    this.getBodyBproject(this.detailProject, id, page, hasMp);
  }

  getProjectStatus(status) {
    if (status < 4) {
      return 'Futuros';
    }
    if (status === 4 || status === 12) {
      return 'En Financiación';
    }
    return 'Financiados';
  }

  setTitleMeta(title, meta) {
    if (title) {
      this.title.setTitle('Fundeen - ' + title);
      this.meta.updateTag({ property: 'og:title', content: title });
      this.meta.updateTag({ name: 'title', content: title });
    } else {
      this.title.setTitle('Fundeen - ' + this.detailProject.name);
      this.meta.updateTag({ property: 'og:title', content: 'Fundeen' });
      this.meta.updateTag({ name: 'title', content: 'Fundeen' });
    }
    if (meta) {
      this.meta.updateTag({ property: 'og:description', content: meta });
      this.meta.updateTag({ name: 'description', content: meta });
    } else {
      this.meta.updateTag({ property: 'og:description', content: 'Fundeen' });
      this.meta.updateTag({ name: 'description', content: 'Fundeen' });
    }
  }

  getBodyBproject(project, id, page, hasMp) {
    this.project = project;
    if ((project.status > 4 && project.status < 12) || project.status === 17) {
      // Evito traer updates, prevision de pagos futuros, etc si el proyecto no está financiado
      this.getHeaderInfo(project, page, hasMp);
    }
    this.getAboutProjectInfo(project);
    this.getInvestorsInfo(project);
    this.getConsumerInfo(project);
    this.getConstructorInfo(project);
    this.getManagementInfo(project);
    this.overviewService.getStatusProject(id).subscribe((info) => {
      this.contributedInfo = info;
      if (this.detailProject.id === 162) {
        info.contributed = info.contributed + 93000;
        info.objective = info.objective + 93000;
      }
      this.getStatusAside(project, info);
      this.chdRef.detectChanges();
    });
    this.overviewService.getProjectFiles(id).subscribe(
      (files) => {
        this.documents = files.documents;
        this.secondaryDocsLits = this.documents.filter((item) => item['type'] === 13);
        this.hasDocuments = true;
        this.loadingFiles = false;
        this.elementList.push({
          name: 'Comisiones',
          id: 'commisions'
        });
        this.elementList.push({
          name: this.translate.instant('OVERVIEW.DOC'),
          id: 'doc',
        });
        this.parseContractSummary();
        this.getMapInfo(project.localization);
        this.chdRef.detectChanges();
      },
      (error) => {
        this.loadingFiles = false;
        this.parseContractSummary();
        this.getMapInfo(project.localization);
        this.chdRef.detectChanges();
      }
    );
    this.isLoaded = true;
  }

  async parseContractSummary() {
    this.hasContractSummary = false;
    this.contractSummary = this.project.locale;

    const hasContent = Object.values(this.project.locale).some(
      (locData: any) =>
        (Array.isArray(locData?.contract_summary) && locData.contract_summary.length > 0) ||
        (Array.isArray(locData?.faq) && locData.faq.length > 0)
    );
    if (hasContent || this.detailProject['show_priority_groups_timeline']) {
      this.hasContractSummary = true;
      this.elementList.push({
        name: this.translate.instant('OVERVIEW.DOCUMENTATION.SUMMARY'),
        id: 'summary',
      });
    }

    if (this.hasContractSummary) {
      this.overviewService.getWalletStatus().subscribe(resp => {
        this.walletStatus = resp.walletstatus;
      }, error => {
        this.walletStatus = null;
      });
    }
  }

  async getHeaderInfo(project, cPage, hasMp) {
    this.overviewService.getUpdateProject(this.id).subscribe(
      (resp) => {
        this.updates = resp.reverse();
        this.getItems();
        this.hasupdates = true;
        this.setHeaderInfo(project, cPage, hasMp, this.hasupdates);
        this.chdRef.detectChanges();
      },
      (error) => {
        this.hasupdates = false;
        this.setHeaderInfo(project, cPage, hasMp, this.hasupdates);
        this.chdRef.detectChanges();
      }
    );
  }

  async setHeaderInfo(project, cPage, hasMp, hasupdates) {
    let prc;
    let image;
    if (this.setPriceCapital() && this.setPriceCapital() !== undefined) {
      prc = this.setPriceCapital();
    } else {
      prc = undefined;
    }
    if (project.imageMain) {
      image = project.imageMain;
    } else {
      image = undefined;
    }

    // this.headerInfo = {
    //   hasMarketplace: hasMp,
    //   hasUpdates: hasupdates,
    // };
    // if (hasupdates) {
    //   const el = {
    //     icon: 'clock',
    //     title: this.translate.instant('UPDATES.UPDATES'),
    //     subtitle: this.translate.instant('LIST_OF_PROJECTS.VIEW_NEWS'),
    //     id: 'news',
    //     border: true
    //   }
    //   this.pageList.push(el);
    //   this.chdRef.detectChanges();
    // }
    if (hasMp) {
      const el = {
        icon: 'file',
        title: this.translate.instant('MOVEMENTS.NOTICEBOARD'),
        subtitle: this.translate.instant('LIST_OF_PROJECTS.MKP_LIST'),
        id: 'marketplace',
        border: true
      }
      this.pageList.push(el);
      this.chdRef.detectChanges();
    }
    this.loadedUpdates = true;
    await this.checkDocumentation();
    await this.checkPaymentCalendar();
    await this.checkMeetingList();
  }

  getAboutProjectInfo(project) {
    let image: any;
    let txt: string;
    if (project.images && project.images !== undefined && project.images[0]) {
      image = project.images;
    } else if (project.imageCard) {
      image = [project.imageCard];
    } else if (project.imageMain) {
      image = [project.imageMain];
    }

    if (project.locale && project.locale !== undefined) {
      const locData = this.getInfoTextLan(project.locale);
      if (locData) {
        if (locData.description_long !== undefined) {
          txt = locData.description_long;
        } else if (locData.description !== undefined) {
          txt = locData.description;
        } else {
          txt = '';
        }
      } else {
        txt = '';
      }
    } else {
      txt = '';
    }

    this.aboutSection = true;
    if (txt === null || txt === undefined || txt === '') {
      this.aboutProjectInfo = {
        id: project.id,
        text: '<p>Proximamente...</p>',
        imageUrl: image,
        status: this.detailProject.status
      };
    } else {
      this.aboutProjectInfo = {
        id: project.id,
        text: txt,
        imageUrl: image,
        status: this.detailProject.status
      };
    }

    this.elementList.push({
      name: this.translate.instant('OVERVIEW.ABOUT'),
      id: 'about',
    });

    if (this.aboutSection) {
      this.headerOffsetMenu = 'about';
    } else {
      this.headerOffsetMenu = 'investors';
    }
  }

  getInvestorsInfo(project) {
    let consumerMoney;
    let constructorMoney;
    let managerMoney;
    if (project.consumerPercentaje) {
      consumerMoney = project.consumerPercentaje;
    } else {
      consumerMoney = 0;
    }
    if (project.constructorPercentage) {
      constructorMoney = project.constructorPercentage;
    } else {
      constructorMoney = 0;
    }
    if (project.managerPercentage) {
      managerMoney = project.managerPercentage;
    } else {
      managerMoney = 0;
    }
    this.investorsInfo = {
      status: project.status,
      fundeenMoney: project.fundeen_percentage,
      consumer: consumerMoney,
      constructor: constructorMoney,
      manager: managerMoney,
      investorLevel: {
        first: project.inversors_profile.range_0.total,
        second: project.inversors_profile.range_1.total,
        third: project.inversors_profile.range_2.total,
        fourth: project.inversors_profile.range_3.total,
      },
    };
    this.elementList.push({
      name: this.translate.instant('OVERVIEW.INVESTORS'),
      id: 'investors',
    });
  }

  getConsumerInfo(project) {
    // De momento no existen datos de back para esto Aqui trataria el consumerInfo de la siguiente manera
    if (project.consumer) {
      this.hasConsumer = true;
      this.elementList.push({
        name: 'Consumidor',
        id: 'consumer',
      });
    }
    /*
      consumerInfo = {
    // Esta es la del promotor
    description: 'Espinosa Golf Design es una firma especializada en la realización de diseños y ' +
    'proyectos de campos de golf, con una experiencia de más de 45 años en la industria del golf y más de 40 campos de golf diseñados y/o proyectados. ',
    name: 'Espinosa Golf',
    location: 'Avila, España',
    image: 'https://fundeen-front-images.s3-eu-west-1.amazonaws.com/pro/projects/20/.jpg',
    document: {
      size: 125,
      name: 'información financiera',
      type: 4,
      url: 'https://service.fundeen.com/apiservices/project/v1/projects/20/files/11f41efa-4a9f-45a8-9872-1ef2e8325093'
    }
  };
    */
  }

  getConstructorInfo(project) {
    if (project.promoter && project.promoter !== undefined) {
      let webPage;
      if (project.promoter.web && project.promoter.web !== undefined) {
        webPage = project.promoter.web;
      } else {
        webPage = undefined;
      }
      this.promoterSection = true;
      this.constructorInfo = {
        description: project.promoter.description,
        name: project.promoter.name,
        location: project.promoter.location,
        web: webPage,
        responsible: {
          team: project.promoter.team,
          other_projects: project.promoter.other_projects,
        },
        image: project.promoter.image
      };
      this.elementList.push({
        name: this.translate.instant('OVERVIEW.TEAM_C'),
        id: 'teamB',
      });
    } else {
      this.promoterSection = false;
    }
  }

  getManagementInfo(project) {
    if (project.manager_team && project.manager_team !== undefined) {
      let webPage;
      if (project.manager_team.web && project.manager_team.web !== undefined) {
        webPage = project.manager_team.web;
      } else {
        webPage = undefined;
      }
      this.managerSection = true;
      this.managementInfo = {
        description: project.manager_team.description,
        location: project.manager_team.location,
        name: project.manager_team.name,
        web: webPage,
        responsible: {
          team: project.manager_team.team,
          other_projects: project.manager_team.other_projects,
        },
      };
      this.elementList.push({
        name: this.translate.instant('OVERVIEW.TEAM_M'),
        id: 'teamM',
      });
    } else {
      this.managerSection = false;
    }
  }

  getStatusAside(project, info) {
    if (project.status === 15) {
      this.overviewService.getTotalProjectreservedByUser(this.id).subscribe(userRes => {
        if (userRes.length > 0) {
          userRes.forEach(element => {
            element['invested'] = element.amount;
            element['date'] = element.creation_date;
          });
          this.getAsideData(project, info, userRes);
        } else {
          this.getAsideData(project, info);
        }
        this.chdRef.detectChanges();
      }, error => {
        this.getAsideData(project, info);
      });
    } else {
      this.overviewService.getHasInvest(this.id).subscribe(
        (resp) => {
          this.isInvestor = true;
          this.checkProduction();
          if (project.status !== 4 && project.status !== 12 && project.status !== 5) {
            this.getAsideData(project, info, resp);
          } else {
            this.overviewService.getPreviousInvestList(this.id).subscribe(response => {
              this.cancelableInvests = response.filter((item) => item['isCancelable'] === true);
              this.investmentsPendingSign = response.filter((item) => item['status'] === -2);
              const canCancel = this.cancelableInvests.length > 0 ? true : false;
              this.prevInvestments = response;
              this.getAsideData(project, info, resp, canCancel);
            }, error => {
              this.getAsideData(project, info, resp);
            });
          }
          this.chdRef.detectChanges();
        },
        (error) => {
          this.getAsideData(project, info);
          this.isInvestor = false;
          this.storage.get('USERDATA').then(val => {
            const vipList = [
              'emi_jmn91@hotmail.com',
              'info@fundeen.com',
              'victor.gutierrez@fundeen.com'
            ];
            if (vipList.some(element => element === val.username)) {
              this.checkProduction(true);
            } else {
              this.checkedNoHasMonitoring = true;
            }
          });
          this.chdRef.detectChanges();
        }
      );
    }
  }

  getAsideData(project, info, invested?, showCancelinvestBtn?) {
    this.reserved = info.reserved;
    this.alreadyInvested = invested;
    this.statusAside = {
      total: info.objective,
      power: project.power,
      status: project.status,
      investmentRiskLevel: project.investmentRiskLevel,
      contributed: info.contributed,
      preordered: info.preordered,
      autoinvested: info.autoinvested,
      autoinvestedPreordered: info.autoinvestedPreordered,
      id: project.id,
      end_date: project.end_date,
      start_date: project.start_date,
      investors: project.inversors_profile.range_0.total + project.inversors_profile.range_1.total + project.inversors_profile.range_2.total + project.inversors_profile.range_3.total,
      totalProfit: project.totalProfit,
      revenueCalculatorMultiplier: project.revenueCalculatorMultiplier,
      co2: project.co2,
      term: project.term,
      activateInvest: this.activateInvest,
      ticketM: info.averageInvestment,
      prevInvest: invested,
      end_build_date: project.end_build_date,
      hasMarketplace: this.hasMarketplace,
      available: this.available,
      start_build_date: project.start_build_date,
      start_util_date: project.start_util_date,
      end_util_date: project.end_util_date,
      co2kwh: project.co2kwh,
      postalCodeToInvest: project.investment_by_postal_code_enabled,
      postalCodeDate: project.investment_unlock_date_by_user_postal_code,
      postalCodeCanInvest: project.user_can_invest_by_postal_code_now,
      canCancel: showCancelinvestBtn,
      max_allowed_amount_to_invest_for_user: project.max_allowed_amount_to_invest_for_user,
      capital_increase_amount: project.capital_increase_amount,
      capital_increase_private_end_date: project.capital_increase_private_end_date,
      profitability: project.profitability,
      hasDocuments: this.hasDocuments,
      type: this.project.type,
      slug: this.detailProject.slug,
      investmentsPendingSign: this.investmentsPendingSign,
      reserved: info.reserved,
      total_official: this.detailProject.total_official,
      technology: this.detailProject.technology,
      rechargePoints: this.detailProject.rechargePoints,
      technologyUnit: this.detailProject.technologyUnit ? this.detailProject.technologyUnit : '',
      technologyAmount: this.detailProject.technologyAmount ? this.detailProject.technologyAmount : '',
      prevInvestmentsAndReservesWithDetail: this.prevInvestments
    };
    if (this.detailProject.status === 15) {
      this.overviewService.getTotalReservedAmount(this.id).subscribe(resp => {
        this.statusAside['contributed'] = resp;
        this.hasStatusaside = true;
        this.chdRef.detectChanges();
      }, error => {
        this.hasStatusaside = true;
        this.chdRef.detectChanges();
      });
    } else {
      if (this.detailProject.status === 4 || this.detailProject.status === 12) {
        this.overviewService.getTotalReservedAmount(this.id).subscribe(resp => {
          this.statusAside['contributed_intention'] = resp;
          this.contributed_intention = resp;
          this.hasStatusaside = true;
          this.chdRef.detectChanges();
        }, error => {
          this.statusAside['contributed_intention'] = 0;
          this.contributed_intention = 0;
          this.hasStatusaside = true;
          this.chdRef.detectChanges();
        });
      } else {
        this.hasStatusaside = true;
        this.chdRef.detectChanges();
      }
    }
    this.chdRef.detectChanges();
  }

  getMapInfo(project) {
    this.zoom = 16;
    this.mapText = project.label;
    this.lat = project.lat;
    this.lon = project.lng;
    this.elementList.push({
      name: this.translate.instant('OVERVIEW.LOCATION'),
      id: 'map',
    });
  }

  getItems() {
    const financing = this.updates.filter((item) => item.category === 1);
    const construction = this.updates.filter((item) => item.category === 2);
    const operation = this.updates.filter((item) => item.category === 3);
    const dividend = this.updates.filter((item) => item.category === 4);
    const others = this.updates.filter((item) => (item.category === 5 || item.category === 0));

    this.listOfFilter.push(this.translate.instant('UPDATES.DATE'));
    if (financing.length > 0) {
      this.listOfFilter.push(this.translate.instant('UPDATES.FINANCING'));
    }
    if (construction.length > 0) {
      this.listOfFilter.push(this.translate.instant('UPDATES.CONSTRUCTION'));
    }
    if (operation.length > 0) {
      this.listOfFilter.push(this.translate.instant('UPDATES.OPERATION'));
    }
    if (dividend.length > 0) {
      this.listOfFilter.push(this.translate.instant('UPDATES.DIVIDEND'));
    }
    if (others.length > 0) {
      this.listOfFilter.push(this.translate.instant('UPDATES.OTHERS'));
    }
    this.realUpdates = this.updates;
  }

  getInfoTextLan(locale) {
    return locale[this.translate.currentLang] || locale['es'];
  }

  controlAsideStyle(evt) {
    const elementList = [this.investors, this.consumer, this.teamB, this.teamM, this.doc, this.summary, this.map];
    const elList = [];
    elementList.forEach((element) => {
      if (element.nativeElement.offsetTop <= evt.detail.scrollTop + element.nativeElement.clientHeight / 4) {
        elList.unshift(element);
      }
    });
    const el = elList[0];
    if (el && el.nativeElement) {
      this.headerOffsetMenu = el.nativeElement.id;
    }
  }

  completeProfile(modalParams, profile, operation) {
    let i = 0;
    this.modalService.removeModal();
    this.authService.completeProfile(profile, modalParams, operation);
    this.authService.readyToInvestEvent.subscribe(() => {
      if (i < 1) {
        this.openInvestModal();
        i++;
      }
    });
  }

  openInvestModal() {
    this.amount = '';
    if (this.available) {
      this.storage.get('WALLET').then((val) => {
        if ((val !== null && val !== undefined && (val.walletstatus === 0 || val.walletstatus === -1)) || this.isWalletOk) {
          this.getInvestInfo();
        } else {
          this.modalService.showModal(SkeletonListComponent, {}, 'Invertir').subscribe((modal: any) => {
            modal.getChildComponent().subscribe((componentRef: SkeletonListComponent) => {
              this.profile$.subscribe((resp) => {
                const params = this.profileService.profileStepsToInvest(resp, this.detailProject.type);
                const modalParams = {
                  profile: resp,
                  list: params['stepList'],
                  towns: { list: undefined, call: this.profileService },
                  updateSpecificDocument: true
                };
                if (params['addNie']) modalParams['addSpecificNie'] = true;
                this.completeProfile(modalParams, resp, 'invest');
              }, error => {
                this.profileService.getUserData().subscribe(response => {
                  if (response.blocked) {
                    this.authService.logout();
                  }
                  const prof = {
                    mailVerified: response.enabled,
                    mobileVerified: response.mobileVerified,
                    username: response.username,
                    mobile: response.mobile,
                    profileType: response.profileType
                  }
                  this.profile = prof;

                  const params = this.profileService.profileStepsToInvest(prof, this.detailProject.type);
                  const modalParams = {
                    profile: prof,
                    list: params['stepList'],
                    towns: { list: undefined, call: this.profileService },
                    updateSpecificDocument: true
                  };
                  if (params['addNie']) modalParams['addSpecificNie'] = true;
                  this.completeProfile(modalParams, prof, 'invest');
                });
              });
            });
          });
        }
      });
    } else {
      let modalParams;
      if (this.project.status === 12 || this.project.status === 14) {
        modalParams = {
          text: this.project.status === 12 ? this.translate.instant('MESSAGES.RECURRENT_INVESTORS') : this.translate.instant('MESSAGES.CAPITAL_INCREASE'),
          image: 2
        };
      } else {
        modalParams = {
          text: this.translate.instant('MESSAGES.CLOSED'),
          image: 1
        };
      }
      this.modalService.showModal(OveralMessageComponent, modalParams, 'Invertir').subscribe((modal: any) => {
        modal.onClose().subscribe();
      });
    }
  }

  getInvestInfo() {
    this.modalService.showModal(SkeletonListComponent, {}, 'Invertir').subscribe((modal: any) => {
      modal.getChildComponent().subscribe((componentRef: SkeletonListComponent) => {
        this.profile$.subscribe((resp) => {
          this.profile = resp;
          const params = this.profileService.profileStepsToInvest(resp, this.detailProject.type);
          if (params['stepList'].length === 0) {
            if (!this.profile.mailVerified) {
              this.modalService.removeModal();
              this.verificationMailAdvice(this.profile.username);
            } else {
              let questions;
              let balance;
              if (
                (this.project.type === 1 && !this.profile.convenienceTestShares && this.detailProject.status !== 15) ||
                (this.project.type === 2 && !this.profile.convenienceTestLoan && this.detailProject.status !== 15)
              ) {
                this.getQuestions(this.project.type).subscribe((response) => {
                  questions = response;
                  this.overviewService.getBalance().subscribe((blc) => {
                    balance = blc;
                    this.seeInvestAvailable(questions, this.profile, balance);
                  });
                });
              } else {
                questions = undefined;
                this.overviewService.getBalance().subscribe((blc) => {
                  balance = blc;
                  this.seeInvestAvailable(questions, this.profile, balance);
                });
              }
            }
          } else {
            const modalParams = {
              profile: resp,
              list: params['stepList'],
              towns: { list: undefined, call: this.profileService },
              updateSpecificDocument: true
            };
            if (params['addNie']) modalParams['addSpecificNie'] = true;
            this.completeProfile(modalParams, resp, 'invest');
          }
        }, error => { });
      });
      modal.disableTransitionDown().subscribe();
      modal.onClose().subscribe();
    });
  }
  getQuestions(type) {
    if (type === 1) {
      return this.overviewService.getQuestionsShares();
    }
    return this.overviewService.getQuestionsLoan();
  }
  getCurrentValue(evt) {
    this.currentAmount = evt;
    this.amount = evt;
  }

  seeInvestAvailable(questions, profile, balance) {
    if (this.detailProject.user_can_invest_by_postal_code_now !== false) {
      this.overviewService.getProjectsInvest(this.id).subscribe((resp) => {
        const missing = this.project.total - resp.contributed - resp.reserved;
        if (this.investmentsPendingSign && this.investmentsPendingSign.length > 0) {
          this.modalService.removeModal();
          const docs = this.documents !== null && this.documents !== undefined ? this.documents : [];
          const modalParams = {
            movement: this.investmentsPendingSign[0],
            signDocuments: docs.filter((item) => item.type === 10 || item.type === 11),
            walletBalance: balance ? balance.balance : 0,
            pendingPromos: this.pendingPromos || [],
          };
          this.modalService.showModal(InvestFinishSignComponent, modalParams, '', '', true).subscribe((modal: any) => {
            modal.getChildComponent().subscribe((componentRef: InvestFinishSignComponent) => {
              componentRef.signedEvent.subscribe((res) => {
                this.initPage();
                this.modalService.removeModal();
              });
              componentRef.removeModalEvent.subscribe((res) => {
                this.initPage();
                this.modalService.removeModal();
              });
              componentRef.openMoneyInEvent.subscribe(() => {
                this.modalService.removeModal();
                const navigationExtras: NavigationExtras = { state: { showIban: true } };
                this.navCtrl.navigateRoot([this.localize.translateRoute('/movements')], navigationExtras);
              });
            });
            modal.onClose().subscribe();
          });
        } else if (missing === 0 && resp.reserved === 0) {
          this.modalService.removeModal();
        } else {
          let reserved = [];
          // Mirar el internal id
          this.overviewService.getQueue(this.id).subscribe(response => {
            const reserved_investments = response.reserved_investments;
            if (reserved_investments.length > 0) {
              reserved = reserved_investments.filter((item) => item.response_id === this.user.internalId);
            }
            const hasPriorityGroups = this.detailProject.priority_groups && this.detailProject.priority_groups.length > 0;
            if (missing === 0 && resp.reserved > 0 && reserved.length === 0 && !hasPriorityGroups) {
              this.noInvestReserved();
            } else {
              this.profileService.getPromoCodeInfo().subscribe(resp => {
                this.investProcess(questions, profile, balance, resp, reserved);
              }, error => {
                const refInfo = {
                  isFirstInvestment: false,
                  promotionalCode: ''
                }
                this.investProcess(questions, profile, balance, refInfo, reserved);
              });
            }
          }, error => {
            const hasPriorityGroupsErr = this.detailProject.priority_groups && this.detailProject.priority_groups.length > 0;
            if (missing === 0 && resp.reserved > 0 && reserved.length === 0 && !hasPriorityGroupsErr) {
              this.noInvestReserved();
            } else {
              this.profileService.getPromoCodeInfo().subscribe(resp => {
                this.investProcess(questions, profile, balance, resp, reserved);
              }, error => {
                const refInfo = {
                  isFirstInvestment: false,
                  promotionalCode: ''
                }
                this.investProcess(questions, profile, balance, refInfo, reserved);
              });
            }
          });
        }
      });
    } else {
      this.modalService.removeModal();
      this.openInfoModal();
    }
  }

  investProcess(questions, profile, balance, refInfo, reserved) {
    const allowedAmount = (this.detailProject.allowedAmountModules !== undefined) ? this.detailProject.allowedAmountModules : '';
    const economicR = (this.detailProject.participations_with_economic_rights !== null && this.detailProject.participations_with_economic_rights !== undefined && this.detailProject.status !== 14) ? this.detailProject.participations_with_economic_rights : undefined;
    this.modalService.removeModal();
    this.documents = this.documents !== null && this.documents !== undefined ? this.documents : [];
    const image = this.detailProject.imageMain !== null && this.detailProject.imageMain !== undefined ? this.detailProject.imageMain : this.detailProject.imageCard;
    //let profit = this.associatedProjectData !== null && this.associatedProjectData !== undefined && this.associatedProjectData['profitability'] !== null && this.associatedDataShowed ? this.associatedProjectData['profitability'] : this.detailProject.profitability;

    let technologyText = 'Otra';
    switch (this.detailProject.technology) {
      case 1:
        technologyText = this.translate.instant('PROJECT.TECHNOLOGY.SOLAR');
        break;
      case 2:
        technologyText = this.translate.instant('PROJECT.TECHNOLOGY.WIND');
        break;
      case 3:
        technologyText = this.translate.instant('PROJECT.TECHNOLOGY.HYBRID');
        break;
      case 4:
        technologyText = this.translate.instant('PROJECT.TECHNOLOGY.CHARGING_POINTS');
        break;
      default:
    }

    const info = {
      headerInfo: {
        profitability: this.detailProject.profitability,
        name: this.detailProject.name,
        end_date: this.detailProject.end_date,
        term: this.detailProject.term,
        objective: this.detailProject.total,
        objective_official: this.detailProject.total_official,
        contributed: this.statusAside.contributed,
        preordered: this.statusAside.preordered,
        invested: this.alreadyInvested,
        capital_increase_amount: this.detailProject.capital_increase_amount,
        capital_increase_private_end_date: this.detailProject.capital_increase_private_end_date,
        status: this.detailProject.status,
        projectImg: image,
        contributed_intention: this.contributed_intention,
        reserved: this.reserved
      },
      bodyInfo: {
        hasWallet: true,
        convenienceTestShares: profile.convenienceTestShares,
        convenienceTestLoan: profile.convenienceTestLoan,
        prjectType: this.project.type,
        investmentMaximumLoan: profile.investmentMaximumLoan,
        investmentMinimum: profile.investmentMinimum,
        balance: balance.balance,
        blockedMoney: balance.blockedMoney,
        moneyOutBalance: balance.moneyOutBalance,
        identityDocumentType: profile.identityDocumentType,
        term: this.detailProject.term,
        co2: this.detailProject.co2,
        total: this.detailProject.total,
        contributed: this.contributedInfo.contributed,
        preordered: this.contributedInfo.preordered,
        reserved: this.contributedInfo.reserved,
        power: this.project.power,
        co2kwh: this.project.co2kwh,
        allowedAmountModules: allowedAmount,
        isFirstInvestment: refInfo.isFirstInvestment,
        promotionalCode: refInfo.promotionalCode,
        economicRights: economicR,
        pendingP: this.pendingPromos,
        investCommitment: false,
        max_allowed_amount_to_invest_for_user: this.detailProject.max_allowed_amount_to_invest_for_user,
        status: this.detailProject.status,
        reserved_list: reserved,
        mangopayUserId: profile.mangopayUserId || undefined,
        postalCodes: this.detailProject.allowedPostalCodes || undefined,
        slug: this.detailProject.slug,
        isFlexibleCompensation: this.isFlexibleCompensation,
        id: this.id,
        yourInvest: this.alreadyInvested,
        investmentStages: this.detailProject.postal_code_investment_stages || undefined,
        priority_groups: this.detailProject.priority_groups || undefined,
        autoinvest_enabled: this.detailProject.autoinvest_enabled === true
      },
      investInfo: {
        username: profile.username,
        wallet: profile.walletid,
        id: this.id,
        refCode: this.refCode || profile.referralCode
      },
      spanInfo: {
        company: this.detailProject.company,
        location: this.detailProject.location,
        technologyText: technologyText
      },
      signDocuments: this.documents.filter((item) => item.type === 10 || item.type === 11),
      projectDeal: this.projectDeal,
      canChangeStage: this.canChangeStage
    };
    this.amount = this.amount === 0 ? '' : this.amount;
    const localInvest = this.detailProject.status !== 14 && this.detailProject.participations_with_economic_rights !== null && this.detailProject.participations_with_economic_rights !== undefined ? true : false;
    const modalParams = { data: info, test: questions, amount: this.amount, localInvestProject: localInvest, profile: profile };
    const invest = this.detailProject.status !== 15 ? this.detailProject.status === 14 ? this.translate.instant('OVERVIEW.CAPITAL_INCREASE.TITLE') : this.translate.instant('MESSAGES.INVEST') : this.translate.instant('FORMALITIES.RESERVE_PROCESS.RESERVE');
    let hasInvested = false;
    this.modalService.showModal(InvestComponent, modalParams, invest).subscribe((modal: any) => {
      this.modalService.setPageTitle('Fundeen - Invertir');
      // this.checkoutDataLayer(this.detailProject, this.amount, 2);
      modal.setSteps('Inversión', 1, 3);
      modal.notCloseEvent.subscribe((x) => {
        const modalParams = {
          place: 'invest',
        };
        this.alertService.showModal(WarningComponent, modalParams, '', '', true).subscribe((modal: any) => {
          const cancel = this.translate.instant('MESSAGES.CANCEL');
          modal.setTitle(cancel);
          modal.getChildComponent().subscribe((componentRef: WarningComponent) => {
            componentRef.continueClick.subscribe((res) => {
              const currentDealStage = this.projectDeal?.properties?.dealstage;
              const isPreInvestmentStage = currentDealStage === this.HubspotService.getStage('investmentIntention')
                || currentDealStage === this.HubspotService.getStage('reservation')
                || currentDealStage === this.HubspotService.getStage('preinvestment');
              if (isPreInvestmentStage) {
                this.changeHuspotStage('cancel_pre_investment');
              } else {
                this.overviewService.getCancelInvest(this.investId).subscribe((_) => {
                  (this.canceledIds as any[]).push(this.investId);
                  this.changeHuspotStage('cart_abandoned');
                });
              }
              this.alertService.removeModal();
              this.modalService.removeModal();
              if (this.currentAmount === '' || this.currentAmount === null) {
                this.amount = '';
              }
            });
          });
          modal.onClose().subscribe();
        });
      });
      modal.getChildComponent().subscribe((componentRef: InvestComponent) => {
        this.currentInvestComponentRef = componentRef;
        if (this.pendingInvestCall) {
          componentRef.showPendingLoader();
        }
        componentRef.dontChangeHubspotStageEvent.subscribe((updatedDeal) => {
          this.canChangeStage = false;
          if (updatedDeal) {
            this.projectDeal = updatedDeal;
          }
        });
        componentRef.cancelInvestEvent.subscribe((resp) => {
          this.canceledIds.push(this.investId);
          modal.changeOpenStatus(false);
        });
        componentRef.keepOpenEvent.subscribe((x) => {
          modal.changeOpenStatus(true);
        });
        componentRef.amountValueEvent.subscribe(value => {
          //this.getCurrentValue(value);
        });
        componentRef.notKeepopenEvent.subscribe((x) => {
          modal.changeOpenStatus(false);
        });
        componentRef.shareTestEvent.subscribe((resp) => {
          this.shareConvenienceTest(resp, profile);
        });
        componentRef.investEvent.subscribe((params) => {
          if (this.pendingInvestCall) { return; }

          this.amount = params.model.amount;
          this.pendingInvestCall = true;

          // this.checkoutDataLayer(this.detailProject, this.amount, 4);
          const model = params.model;
          model.application = 'app';
          const id = params.id;
          this.overviewService.invest(model, id).subscribe(
            (resp) => {
              this.pendingInvestCall = false;
              const activeRef = this.currentInvestComponentRef;
              if (!activeRef) { return; }
              this.investId = resp.transaction?.id;
              activeRef.setInvestId(this.investId);
              // guardar resp.id para poder cancelar la llamada
              const evironmentUrlLemonway = environment.endPointLW;
              const c = { response: resp, urlLw: evironmentUrlLemonway };
              activeRef.getInvestResponse(c);
              if (activeRef.hasToBookInvestment && this.projectDeal?.id) {
                this.HubspotService.updateDeal(this.projectDeal.id, 'preinvestment', { amount: this.amount || 0 }).subscribe(
                  (resHusbpot: any) => {
                    this.canChangeStage = false;
                    if (resHusbpot?.data) {
                      this.projectDeal = resHusbpot.data;
                    }
                    this.chdRef.detectChanges();
                  },
                  (err: any) => {
                    console.error('[HubSpot] Error setting preinvestment from overview:', err);
                  }
                );
              }
              this.chdRef.detectChanges();
            },
            (error) => {
              this.pendingInvestCall = false;
              const activeRef = this.currentInvestComponentRef;
              if (!activeRef) { return; }
              const errors = [];
              if (error.error.errors && error.error.errors.length > 0) {
                error.error.errors.forEach((error) => {
                  errors.push(error);
                });
              }
              if (error.status === 400) {
                errors.push(400);
              }
              activeRef.getErrors(errors);
              this.chdRef.detectChanges();
            }
          );
          this.chdRef.detectChanges();
        });

        componentRef.investByWalletEvent.subscribe((resp) => {
          this.finishedInvest = true;
          this.transactionId = resp.id;
          let timeOut = false;
          let isSuccessInvest;
          let idCanceled = false;

          this.canceledIds.forEach(element => {
            if (element === resp.id) {
              idCanceled = true;
            }
          });

          if (!idCanceled) {
            this.overviewService.finishInvest(resp.id).subscribe(
              (response) => {
                isSuccessInvest = true;
                timeOut = true;
                hasInvested = true;
                this.isHubspodDealOkInCurrentInvest = true;
                componentRef.confirmInvest(true);
                this.chdRef.detectChanges();
              },
              (error) => {
                // Mostrar mensaje de error
                isSuccessInvest = false;
                const errors = [];
                if (error.error.errors) {
                  error.error.errors.forEach((error) => {
                    errors.push(error);
                  });
                }
                if (error.status === 400) {
                  errors.push(400);
                }
                componentRef.getErrors(errors);
              }
            );
            setTimeout(() => {
              if (!timeOut && (!isSuccessInvest || isSuccessInvest === undefined)) {
                this.investCardService.getInfoMovement(resp.id).subscribe(() => {
                  hasInvested = true;
                  componentRef.confirmInvest(true);
                }, error => {
                  componentRef.confirmInvest(false);
                });
              }
            }, 180000);
          }
        });
        componentRef.signaturitIssueEvent.subscribe(resp => {
          // this.checkoutDataLayer(this.detailProject, this.amount, 6);
        });
        componentRef.goToHomeEvent.subscribe(() => {
          this.navCtrl.navigateRoot([this.localize.translateRoute('/portfolio')]);
          this.modalService.removeModal();
        });
        componentRef.newInvestEvent.subscribe(() => {
          this.initPage();
          this.modalService.removeModal();
        });
        componentRef.investmentQueueEvent.subscribe((resp) => {
          this.noInvestReserved();
        });
        componentRef.getPayTypeEvent.subscribe((resp) => {
          this.typePay = resp.methos;
          // this.checkoutDataLayerPayType(this.detailProject, resp.cashForm.value.cash, 3, resp.methos);
        });
        componentRef.getCodePromotionEvent.subscribe((resp) => {
          this.cuopon = resp;
          this.storage.remove('PROMO');
          this.storage.set('PROMO', resp);
        });
        componentRef.startSignEvent.subscribe((resp) => {
          // this.checkoutDataLayerStartSign(this.detailProject, this.amount, 5, this.typePay);
        });
        componentRef.confirmInvestWalletEvent.subscribe((resp) => {
          this.storage.get('NAME').then((val) => {
            this.nameUser = val;
          });
          // this.checkoutDataLayerInvestWalletOK(this.detailProject, this.amount, resp, this.cuopon, this.nameUser, this.typePay);
        });
        componentRef.purchaseEvent.subscribe((resp) => {
          // this.checkoutDataLayerInvestCardOK(resp);
        });
        componentRef.stepsEvent.subscribe((resp) => {
          modal.setSteps(resp.title, resp.step, resp.total);
        })
        componentRef.closeAndCheckIbanEvent.subscribe(resp => {
          this.modalService.removeModal();
          const navigationExtras: NavigationExtras = {
            state: {
              showIban: true,
            }
          };
          this.navCtrl.navigateRoot([this.localize.translateRoute('/movements')], navigationExtras);
        });
      });
      modal.closeEvent.subscribe(() => {
        if (this.currentAmount === '' || this.currentAmount === null) {
          this.amount = '';
        }
        this.initPage();
      });
      modal.onClose().subscribe();
      modal.disableTransitionUp().subscribe();
    });
  }

  noInvestReserved() {
    this.modalService.removeModal();
    const data$ = this.overviewService.getQueue(this.id);
    const modalParams = {
      data: data$
    };
    this.alertService.showModal(InvestReservedComponent, modalParams, 'Invertir').subscribe((modal: any) => {
      this.modalService.setPageTitle('Fundeen - Invertir');
      modal.getChildComponent().subscribe((componentRef: InvestReservedComponent) => {
        componentRef.cancelEvent.subscribe((x) => {
          this.alertService.removeModal();
        });
        componentRef.continueEvent.subscribe((x) => {
          this.getInvestInfo();
          this.alertService.removeModal();
        });
      });
      modal.onClose().subscribe();
    });
  }

  viewProjects(value) {
    const navigationExtras: NavigationExtras = {
      state: {
        id: value.id,
        page: 'overview',
      },
    };
    this.storage.set('LASTPAGE', navigationExtras);
    const slugOrId = value.slug && value.slug !== undefined && value.slug !== undefined ? value.slug : value.id;
    this.navCtrl.navigateRoot([this.localize.translateRoute(`/overview-project/${slugOrId}`)], navigationExtras);
  }

  viewNavclick(event) {
    this.currentPage = event;
    if (event === 'monitoring' && (this.lastUpdate > 2 || (this.lastUpdate === undefined && this.checkedNoHasMonitoring))) {
      const modalParams = {
        text: this.translate.instant('OVERVIEW.NO_PROD_DATA'),
        btnList: [
          {
            type: 'primaryDark',
            index: 1,
            title: this.translate.instant('MESSAGES.BACK'),
          }
        ]
      };
      this.alertService.showModal(OveralMessageComponent, modalParams, '', '', true).subscribe((modal: any) => {
        modal.getChildComponent().subscribe((componentRef: OveralMessageComponent) => {
          componentRef.btnEvent.subscribe((resp) => {
            this.alertService.removeModal();
            this.viewNavclick('overview');
          });
        });
        modal.onClose().subscribe();
      });
    }
  }

  controlAsideBtn(evt) {
    switch (evt) {
      case 'offer':
        this.createOffer();
        break;
      case 'updates':
        this.currentPage = 'news';
        break;
      case 'marketplace':
        this.currentPage = 'marketplace';
        break;
      case 'invest':
        if (!this.authService.isRefreshExpired()) {
          this.openInvestModal();
          this.dataLayerService.pushEcomEventGTM('add_to_cart', {
            'currency': 'EUR',
            'items': [{
              'item_id': this.detailProject.id,
              'item_name': this.detailProject.name,
              'price': 500,
              'quantity': 1
            }]
          });
          this.changeHuspotStage('add_to_cart');
        } else if (!this.authService.isMobileExpired()) {
          // Abro el alert y luego le mando al open de arriba
          this.renewSession('invest');
          // this.authService.refreshLoginevent.subscribe((action) => {
          //   if (action === 'invest') {
          //     //this.openInvestModal();
          //   }
          // });
        }
        break;
      case 'call':
        this.stayInformed();
        break;
    }
  }

  returntNav() {
    this.navCtrl.navigateRoot([this.localize.translateRoute('/list-of-projects')]);
  }

  public openWalletNotReady(createBidToOfferData: MarketPlaceBidCreateModel) {
    this.modalService.showModal(SkeletonListComponent, {}, 'Invertir').subscribe((modal: any) => {
      modal.getChildComponent().subscribe(() => {
        this.profile$.subscribe((resp) => {
          const profileParams = this.profileService.profileStepsToInvest(resp, this.detailProject.type);
          if (profileParams['stepList'].length === 0) {
            this.modalService.removeModal();
            this.actionBidOrSca(createBidToOfferData, resp);
          } else {
            const modalParams = {
              profile: resp,
              list: profileParams['stepList'],
              towns: { list: undefined, call: this.profileService },
              updateSpecificDocument: true
            };
            if (profileParams['addNie']) modalParams['addSpecificNie'] = true;
            this.completeProfile(modalParams, resp, 'bid');
            this.authService.readyToBid.subscribe(() => {
              if (!this.authService.isRefreshExpired()) {
                this.storage.get('WALLET').then((val) => {
                  if (val?.walletstatus === 0) {
                    this.actionBid(createBidToOfferData as any, resp);
                  } else {
                    this.actionBidOrSca(createBidToOfferData, resp);
                  }
                });
              }
            });
          }
        });
      });
    });
  }

  private actionBidOrSca(createBidToOfferData: MarketPlaceBidCreateModel, profile: any) {
    if (
      (this.project.type === 1 && !profile.convenienceTestShares) ||
      (this.project.type === 2 && !profile.convenienceTestLoan)
    ) {
      this.getQuestions(this.project.type).subscribe((response) => {
        const modalParams = { testInfo: response, profile };
        this.modalService.removeModal();
        this.modalService.showModal(InvestTestConvenienceComponent, modalParams, '', '', true).subscribe((modal: any) => {
          modal.getChildComponent().subscribe((componentRef: InvestTestConvenienceComponent) => {
            componentRef.emitSuccess.subscribe((testResp) => {
              this.modalService.removeModal();
              this.shareConvenienceTest(testResp, profile);
              this.checkScaOrShowValidation(profile);
            });
            componentRef.testFail.subscribe((testResp) => {
              this.modalService.removeModal();
              this.shareConvenienceTest(testResp, profile);
              this.checkScaOrShowValidation(profile);
            });
          });
        });
      });
    } else {
      this.checkScaOrShowValidation(profile);
    }
  }

  private checkScaOrShowValidation(profile: any) {
    const scaParams = this.utilsService.getMangopayValidationParams(profile);
    if (scaParams !== null) {
      this.alertService.showModal(MangopayScaValidationComponent, scaParams, '', '', true).subscribe((modal: any) => {
        modal.getChildComponent().subscribe((componentRef: MangopayScaValidationComponent) => {
          componentRef.finishEvent.pipe(take(1)).subscribe(() => {
            this.alertService.removeModal();
            this.showMangopayValidationMsg();
          });
          componentRef.removeModalEvent.subscribe(() => {
            this.alertService.removeModal();
          });
        });
        modal.onClose().subscribe();
        modal.activeCross().subscribe();
      });
    } else {
      this.showMangopayValidationMsg();
    }
  }

  private showMangopayValidationMsg() {
    const msgParams = { text: this.translate.instant('INVEST.MANGOPAY_VALIDATION'), image: 2 };
    this.modalService.showModal(OveralMessageComponent, msgParams, '').subscribe((modal: any) => {
      modal.onClose().subscribe();
    });
  }

  public createBid(createBidToOfferData: MarketPlaceOfferCreateModel) {
    this.modalService.showModal(SkeletonListComponent, {}, 'Invertir').subscribe((modal: any) => {
      modal.getChildComponent().subscribe((componentRef: SkeletonListComponent) => {
        this.profile$.subscribe((resp) => {
          const params = this.profileService.profileStepsToInvest(resp, this.detailProject.type);
          if (params['stepList'].length === 0) {
            this.modalService.removeModal();
            if (!this.authService.isRefreshExpired()) {
              this.actionBid(createBidToOfferData, resp);
            } else if (!this.authService.isMobileExpired()) {
              this.renewSession('createBid');
              // this.authService.refreshLoginevent.subscribe((action) => {
              //   if (action === 'createBid') {
              //     this.actionBid(createBidToOfferData, resp);
              //   }
              // });
            }
          } else {
            const modalParams = {
              profile: resp,
              list: params['stepList'],
              towns: { list: undefined, call: this.profileService },
              updateSpecificDocument: true
            };
            if (params['addNie']) modalParams['addSpecificNie'] = true;
            this.completeProfile(modalParams, resp, 'bid');
            this.authService.readyToBid.subscribe(() => {
              if (!this.authService.isRefreshExpired()) {
                this.actionBid(createBidToOfferData, resp);
              } else if (!this.authService.isMobileExpired()) {
                this.renewSession('createBid');
                // this.authService.refreshLoginevent.subscribe((action) => {
                //   if (action === 'createBid') {
                //     this.actionBid(createBidToOfferData, resp);
                //   }
                // });
              }
            });
          }
        }, error => {
          this.profileService.getUserData().subscribe(response => {
            if (response.blocked) {
              this.authService.logout();
            }
            const prof = {
              mailVerified: response.enabled,
              mobileVerified: response.mobileVerified,
              username: response.username,
              mobile: response.mobile,
              profileType: response.profileType,
            }
            this.profile = prof;

            const params = this.profileService.profileStepsToInvest(prof, this.detailProject.type);
            const modalParams = {
              profile: prof,
              list: params['stepList'],
              towns: { list: undefined, call: this.profileService },
              updateSpecificDocument: true
            };
            if (params['addNie']) modalParams['addSpecificNie'] = true;
            this.completeProfile(modalParams, prof, 'bid');
            this.authService.readyToBid.subscribe(() => {
              if (!this.authService.isRefreshExpired()) {
                this.actionBid(createBidToOfferData, prof);
              } else if (!this.authService.isMobileExpired()) {
                this.renewSession('createBid');
                // this.authService.refreshLoginevent.subscribe((action) => {
                //   if (action === 'createBid') {
                //     this.actionBid(createBidToOfferData, prof);
                //   }
                // });
              }
            });
          });
        });
      });
    });
  }

  manageOffer(offer: MarketPlaceOfferModel) {
    const navigationExtras: NavigationExtras = { state: { openOfferId: offer.id } };
    this.navCtrl.navigateRoot([this.localize.translateRoute('/my-offers')], navigationExtras);
  }

  viewMyBid(offer: MarketPlaceOfferModel) {
    const navigationExtras: NavigationExtras = { state: { openBidForOfferId: offer.id } };
    this.navCtrl.navigateRoot([this.localize.translateRoute('/my-bids')], navigationExtras);
  }

  actionBid(createBidToOfferData: MarketPlaceOfferCreateModel, profile) {
    if ((this.project.type === 1 && !profile.convenienceTestShares) || (this.project.type === 2 && !profile.convenienceTestLoan)) {
      this.modalService.showModal(SkeletonListComponent, {}, 'Invertir').subscribe(() => {
        this.getQuestions(this.project.type).subscribe((response) => {
          this.modalService.removeModal();
          this.modalService.showModal(SkeletonListComponent, {}, 'Invertir').subscribe(() => {
            this.getQuestions(this.project.type).subscribe((response) => {
              const modalParams = { testInfo: response, profile: profile };
              this.modalService.removeModal();
              this.modalService.showModal(InvestTestConvenienceComponent, modalParams, '', '', true).subscribe(modal => {
                modal.getChildComponent().subscribe((componentRef: InvestTestConvenienceComponent) => {
                  componentRef.emitSuccess.subscribe(resp => {
                    this.modalService.removeModal();
                    this.createNewBid(createBidToOfferData);
                    this.shareConvenienceTest(resp, profile);
                  });
                  componentRef.testFail.subscribe(resp => {
                    this.modalService.removeModal();
                    this.createNewBid(createBidToOfferData);
                    this.shareConvenienceTest(resp, profile);
                  });
                });
              });
            });
          });
        });
      });
    } else {
      this.createNewBid(createBidToOfferData);
    }
  }

  createNewBid(createBidToOfferData) {
    const modalParams = { createBidOffer: createBidToOfferData };

    this.modalService.showModal(BidCreateComponent, modalParams, '', '', true).subscribe((modal: any) => {
      this.modalService.setPageTitle(`Fundeen - ${this.translate.instant('MARKETPLACE.BID.CREATE_TITLE')}`);
      modal.setTitle(this.translate.instant('MARKETPLACE.BID.CREATE_TITLE'));
      modal.getChildComponent().subscribe((componentRef: BidCreateComponent) => {
        componentRef.eventConfirmBid.subscribe((resDataBid: any) => {
          this.postBid(resDataBid).subscribe(
            (resPostBid: any) => {
              componentRef.isBidCreated = resPostBid;
              this.getMarketPlaceOffers();
            },
            (error: Error) => {
              componentRef.isBidCreated = false;
            }
          );
        });
        componentRef.eventButtonsRoute.subscribe((resRoute: string) => {
          this.utilsService.navigateTo(`/${resRoute}`);
          // TODO: Eliminar el setTimeout y añadir un loading
          setTimeout(() => modal.close(), 600);
        });
      });
      modal.onClose().subscribe();
    });
  }

  postBid(bid: any): Observable<any> {
    return new Observable((observer) => {
      this.communicationService.post(`${this.urlService}/bid`, bid).subscribe(
        (resPost: string) => {
          if (resPost.toLowerCase() !== 'ok') {
            return observer.error(false);
          }
          observer.next(true);
          return observer.complete();
        },
        () => {
          return observer.error(false);
        }
      );
    });
  }

  async shareConvenienceTest(resp, profile) {
    const fail = resp.sucess;
    const test = resp.test;
    const obj = {
      convenienceTestShares: this.project.type === 1 && !fail ? false : true,
      convenienceTestLoan: this.project.type === 2 && !fail ? false : true,
      username: profile.username,
      log: test,
    };
    // this.overviewService.convenienceTest(obj).subscribe((prof) => {
    //   this.profile = prof;
    // });
  }

  downloadFile(document) {
    this.utils.viewdFile(document);
  }

  downloadDoc(data) {
    let getRes = false;
    setTimeout(() => {
      if (!getRes) {
        this.toastService.showToast(this.translate.instant('MESSAGES.DOCUMENT_DOWNLOAD_WAIT'), 'info', true);
      }
    }, 1500);
    this.overviewService.getUpdateFile(this.id, data.id)
      .subscribe(
        (response) => {
          this.update.downloadedDoc(data.idUp);
          getRes = true;
          const file = new Blob([response], { type: 'application/pdf' });
          const fileURL = window.URL.createObjectURL(file);
          // window.open(fileURL, 'pdf', '_blank');
          const downloadLink = document.createElement('a');
          const fileName = data.fileName + '.pdf';
          downloadLink.href = fileURL;
          downloadLink.download = fileName;
          downloadLink.click();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  async downloadAllDocuments() {
    this.overviewService.getProjectFilesZip(this.id).subscribe((blob: Blob) => {
      if (blob.type && blob.type.includes('json')) {
        // Formato nuevo: el backend devuelve el array de documentos, lo empaquetamos en cliente.
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const documents = JSON.parse(reader.result as string);
            this.utils.generateDocumentsZip(documents, this.detailProject.name, Capacitor.getPlatform()).catch(error => {
              console.error('[downloadAllDocuments] Error generando el zip:', error);
              this.toastService.showToast(this.translate.instant('ERRORS.500'), 'warning');
            });
          } catch (error) {
            console.error('[downloadAllDocuments] Error parseando la respuesta JSON:', error);
            this.toastService.showToast(this.translate.instant('ERRORS.500'), 'warning');
          }
        };
        reader.readAsText(blob);
      } else {
        // Formato antiguo: el backend ya devuelve el .zip real, lo descargamos tal cual.
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${this.detailProject.name}.zip`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    }, error => {
      this.toastService.showToast(this.translate.instant('ERRORS.500'), 'warning');
    });
    const model = {
      project_name: this.detailProject.name,
      project_id: this.detailProject.id,
      project_status: this.detailProject.status,
    };
    this.posthogService.pushEventParams('project_download_documentation', model);
    this.dataLayerService.pushCustomEventGTM('project_download_documentation');
    this.changeHuspotStage('download');
  }

  createOffer() {
    if (!this.authService.isRefreshExpired()) {
      this.offersService.createOffer(this.id);
      this.currentPage = 'marketplace';
      this.offersService.createdOf.subscribe(resp => {
        this.loadingMkp = true;
        this.getMarketPlaceOffers();
      });
    } else if (!this.authService.isMobileExpired()) {
      this.renewSession('createOfOverview');
      // this.authService.refreshLoginevent.subscribe((action) => {
      //   if (action === 'createOfOverview') {
      //     /*this.offersService.createOffer(this.id);
      //     this.offersService.createdOf.subscribe(resp => {
      //       this.getMarketPlaceOffers();
      //     });*/
      //   }
      // });
    }
  }

  public getMarketPlaceOffers() {
    const marketplace$ = this.overviewService.getMarketplaceInfo();
    const myOffers$ = this.communicationService.get('apiservices/marketplace/v1/marketplace/offers', null).pipe(
      catchError(() => of([]))
    );
    forkJoin([marketplace$, myOffers$]).subscribe(([resp, myOffers]: [any[], any[]]) => {
      const myOfferIds = new Set((myOffers || []).map((o: any) => o.id));
      resp.forEach((element) => {
        const idP = parseInt(this.id);
        if (element.id === idP) {
          if (element.offers) {
            element.offers.forEach((offer: MarketPlaceOfferModel) => {
              offer.is_own_offer = myOfferIds.has(offer.id);
            });
          }
          this.projectMarketp = element;
          this.loadingMkp = false;
          this.marketplaceRow?.getData();
        }
      });
    });
  }

  goBack() {
    this.storage.get('LASTPAGE').then((val) => {
      const page = val.state.page;
      if (page === 'overview') {
        this.navCtrl.navigateRoot([this.localize.translateRoute('/list-of-projects')]);
      } else {
        this.location.back();
      }
    });
  }

  getPositionProject() {
    for (let i = 0; i < this.positionIds.length; i++) {
      if (this.positionIds[i] === this.id) {
        return i;
      }
    }
  }

  getFilter(item) {
    this.realUpdates = this.updates;
    let newUpdates = this.realUpdates;
    switch (item) {
      case this.translate.instant('UPDATES.FINANCING'):
        newUpdates = newUpdates.filter((item) => item.category === 1);
        break;
      case this.translate.instant('UPDATES.CONSTRUCTION'):
        newUpdates = newUpdates.filter((item) => item.category === 2);
        break;
      case this.translate.instant('UPDATES.OPERATION'):
        newUpdates = newUpdates.filter((item) => item.category === 3);
        break;
      case this.translate.instant('UPDATES.DIVIDEND'):
        newUpdates = newUpdates.filter((item) => item.category === 4);
        break;
      case this.translate.instant('UPDATES.OTHERS'):
        newUpdates = newUpdates.filter((item) => (item.category === 5 || item.category === 0));
        break;
      default:
        newUpdates = newUpdates;
        break;
    }
    this.realUpdates = newUpdates;
  }

  getPostCodeAvailable() {
    if (this.detailProject.investment_by_postal_code_enabled
      && (this.detailProject.status === 4 || this.detailProject.status === 12 || this.detailProject.status === 3 || this.detailProject.status === 15)) {
      this.investPostalCodeStepsInfo = {
        unlock: this.detailProject.investment_unlock_date_by_user_postal_code,
        steps: this.detailProject.postal_code_investment_stages,
        canInvest: this.detailProject.user_can_invest_by_postal_code_now,
        status: this.detailProject.status
      };
      if (
        this.detailProject.allowedPostalCodesDescription
        && this.detailProject.allowedPostalCodesDescription !== null
        && this.detailProject.allowedPostalCodesDescription !== undefined
      ) {
        this.infoData = {
          txt: this.detailProject.allowedPostalCodesDescription,
          btnTitle: this.translate.instant('INFO.BTN_MSG_BALEARES')
        }
      } else {
        this.infoData = {
          txt: this.translate.instant('INFO.TXT_MSG_BALEARES'),
          btnTitle: this.translate.instant('INFO.BTN_MSG_BALEARES')
        }
      }
    } else if (this.detailProject.status === 14) {
      this.infoData = {
        txt: this.translate.instant('OVERVIEW.CAPITAL_INCREASE.INCREASE_DATE') + this.getEndPrivateDay(),
        btnTitle: this.translate.instant('OVERVIEW.CAPITAL_INCREASE.READ_MORE')
      }
    }
  }

  getEndPrivateDay() {
    const check = moment(this.detailProject.capital_increase_private_end_date, 'YYYY/MM/DD');
    const day = Number(check.format('DD'));
    const month = this.utilsService.parseMonth(Number(check.format('MM')));
    const year = Number(check.format('YYYY'));
    return this.translate.currentLang === 'en' ? `${month} ${day}th, ${year}` : `${day} de ${month} de ${year}`;
  }

  openInfoModal() {
    if (this.project.status === 14) {
      this.overviewService.openCapitalIncreaseMoreInfo(this.available);
      this.overviewService.openInvestEvent.subscribe(() => {
        if (!this.openedFromReadMore) {
          this.openedFromReadMore = true;
          setTimeout(() => {
            this.openedFromReadMore = false;
          }, 300);
        }
      });
    } else {
      this.storage.get('USERDATA').then((prof) => {
        const profTxt = prof.profileType === 1 ? this.translate.instant('INFO.MODAL_TXT_P') : this.translate.instant('INFO.MODAL_TXT_J');
        let txt;
        let img;
        let btnTitle;
        if (this.detailProject.postal_code_verification_pending !== true) {
          this.profile$.subscribe((resp) => {
            this.profile = resp;
            this.storage.set('HS_SURNAME_USER', `${this.profile.name} ${this.profile.surname}`);
            if (this.profile.extraPostalCodes !== null) {
              if (this.detailProject.status === 3) {
                txt = this.translate.instant('LOCAL_INVEST.CANT_INVEST_2', { codes: this.profile.extraPostalCodes });
                img = 6;
                btnTitle = this.translate.instant('INFO.MODAL_BTN');
              } else {
                txt = this.translate.instant('LOCAL_INVEST.CANT_INVEST', { codes: this.profile.extraPostalCodes });
                img = 4
                btnTitle = this.translate.instant('INFO.MODAL_BTN');
              }
            } else {
              const projectListWithEmployeeAndClientInvestmentPhase = environment.projectListWithEmployeeAndClientInvestmentPhase;
              const currentProjectHasEmployeeAndClientInvestmentPhase = projectListWithEmployeeAndClientInvestmentPhase.find(project => project.projectId === this.detailProject['id']);
              if (currentProjectHasEmployeeAndClientInvestmentPhase) {
                txt = this.translate.instant('INFO.MODAL_VINCULATION_TEXT', { project: this.detailProject.name, company: currentProjectHasEmployeeAndClientInvestmentPhase.company });
              } else {
                txt = this.translate.instant('INFO.MODAL_TITLE') + '<p>' + this.translate.instant('INFO.MODAL_TXT_1') + this.detailProject.name + '.' + profTxt + '</p>';
              }
              img = 4;
              btnTitle = this.translate.instant('INFO.MODAL_BTN');
            }
            const modalParams = {
              text: txt,
              image: img,
              btnList: [
                {
                  type: 'primaryDark',
                  index: 1,
                  title: btnTitle,
                }
              ],
            };
            //if (this.detailProject.status !== 15) {
            this.modalService.showModal(OveralMessageComponent, modalParams, '').subscribe((modal: any) => {
              modal.getChildComponent().subscribe((componentRef: OveralMessageComponent) => {
                componentRef.btnEvent.subscribe(() => {
                  this.modalService.removeModal();
                  if (this.detailProject.postal_code_verification_pending !== true) {
                    this.validateAffiliation();
                  }
                });
              });
              modal.onClose().subscribe();
            });
          });


        } else {
          img = 14;
          btnTitle = this.translate.instant('LOCAL_INNVEST.DYNAMIC.FINISH');
          txt = this.translate.instant('LOCAL_INNVEST.DYNAMIC.VALIDATING');
          const modalParams = {
            text: txt,
            image: img,
            btnList: [
              {
                type: 'primaryDark',
                index: 1,
                title: btnTitle,
              }
            ],
          };
          //if (this.detailProject.status !== 15) {
          this.modalService.showModal(OveralMessageComponent, modalParams, '').subscribe((modal: any) => {
            modal.getChildComponent().subscribe((componentRef: OveralMessageComponent) => {
              componentRef.btnEvent.subscribe(() => {
                this.modalService.removeModal();
                if (this.detailProject.postal_code_verification_pending !== true) {
                  this.validateAffiliation();
                }
              });
            });
            modal.onClose().subscribe();
          });
        }

        //} else {
        //this.validateAffiliation();
        //}
      });
    }
  }

  verificationMailAdvice(username) {
    const modalParams = {
      text: this.translate.instant('REGISTER.MY_PROFILE.VERIFY_MAIL'),
      btnList: [
        {
          type: 'primaryDark',
          index: 1,
          title: this.translate.instant('REGISTER.PASSPORT.BTN'),
        },
        {
          type: 'secondary',
          index: 2,
          title: this.translate.instant('REGISTER.MY_PROFILE.SKIP'),
        }
      ],
    };

    this.alertService.showModal(OveralMessageComponent, modalParams, '', '', true).subscribe((modal: any) => {
      modal.getChildComponent().subscribe((componentRef: OveralMessageComponent) => {
        componentRef.btnEvent.subscribe((resp) => {
          if (resp === 1) {
            this.profileService.getMailCode(username).subscribe(() => {
              this.toastService.showToast(this.translate.instant('REGISTER.MY_PROFILE.VERIFY_MAIL_2'), 'info', true);
            });
          }
          this.alertService.removeModal();
        });
      });
      modal.onClose().subscribe();
    });
  }

  sortByDate(arr) {
    arr.sort(function (a, b) {
      return Number(new Date(a.start_date)) - Number(new Date(b.start_date));
    });
    return arr;
  }

  getCurrentStep() {
    const todayParse = new Date(this.convertToIos(moment().tz('Europe/Madrid').format('YYYY-MM-DD HH:mm:ss')));
    const today = moment(todayParse);
    const arr = this.sortByDate(this.detailProject.postal_code_investment_stages);
    let j = 0;
    if (this.detailProject.status === 3) {
      return 0;
    }
    arr.forEach(element => {
      j++;
      element.index = j;
    });

    for (let i = 0; i < arr.length; i++) {
      // const starDateParse = new Date(this.convertToIos(moment(arr[i].start_date).tz('Europe/Madrid').format('YYYY-MM-DD HH:mm:ss')));
      let starDateParse = new Date(this.convertToIos(moment(arr[i].start_date).tz('Europe/Madrid').format('YYYY-MM-DD HH:mm:ss')));
      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        starDateParse = new Date(this.convertToIos(moment(arr[i].start_date.replace('/', '-').replace('/', '-'))
          .tz('Europe/Madrid').format('YYYY-MM-DD HH:mm:ss')));
      }
      const starDate = moment(starDateParse);
      const timeRemaining = starDate.valueOf() - today.valueOf(); //starDate.diff(this.today, 'seconds');

      if (timeRemaining <= 0 && arr.length > i + 1) {
        //const starDateNext = moment(arr[i + 1].start_date, 'YYYY/MM/DD HH:mm:ss').tz('Europe/Madrid');
        let starDateNext = moment(arr[i + 1].start_date, 'YYYY/MM/DD HH:mm:ss').tz('Europe/Madrid');
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
          starDateNext = moment(arr[i + 1].start_date.replace('/', '-').replace('/', '-'), 'YYYY/MM/DD HH:mm:ss').tz('Europe/Madrid');
        }
        const timeRemainingNext = starDateNext.valueOf() - today.valueOf(); // starDateNext.diff(this.today, 'seconds');
        if (timeRemainingNext > (- 60 * 1000 * 60)) {
          return i + 1;
        }
      } else if (arr.length === i + 1) {
        if (timeRemaining <= 0) {
          return i + 1;
        }
      }
      if (this.detailProject.status === 3) {
        return 0;
      }
    }
    this.chdRef.detectChanges();
  }

  validateAffiliation() {
    const modalParams = {
      postalCodeInvestmentStages: this.detailProject.postal_code_investment_stages,
      investmentUnlock: this.detailProject.investment_unlock_date_by_user_postal_code,
      canInvest: this.detailProject.user_can_invest_by_postal_code_now,
      projectName: this.detailProject.name,
      status: this.detailProject.status,
      projectId: this.detailProject.id
    };
    this.modalService.showModal(AffiliationLocalInvestComponent, modalParams, '').subscribe((modal: any) => {
      this.modalService.setPageTitle('Fundeen - Inversión local');
      modal.getChildComponent().subscribe((componentRef: AffiliationLocalInvestComponent) => {
        componentRef.closeModalEvent.subscribe(() => {
          this.modalService.removeModal();
        });
        componentRef.reloadPageEvent.subscribe(() => {
          this.elementList = [];
          this.isLoaded = false;
          if (isNaN(Number(this.slug))) {
            this.overviewService.getProjectDetailBySlug(this.slug).subscribe(proj => {
              this.operate(proj);
              this.chdRef.detectChanges();
            });
          } else {
            this.overviewService.getProjectDetail(this.slug).subscribe(proj => {
              this.operate(proj);
              this.chdRef.detectChanges();
            });
          }
        });
        componentRef.updateDealEvent.subscribe(resp => {
          this.changeHuspotStage(resp);
        });
      });
      modal.onClose().subscribe();
    });
  }

  editInvest() {
    this.overviewService.cancelInvestment(this.cancelableInvests);
    this.overviewService.investrejectedEvent.subscribe((status) => {
      const step = status === -3 ? 'cancel_pre_investment' : 'cancel';
      this.initPage();
      this.changeHuspotStage(step);
      this.isHubspodDealOkInCurrentInvest = false;
    });
  }

  cancelReservation(val) {
    // this.overviewService.getPreviousInvestList(this.id).subscribe(response => {
    //   console.log(response, 'response')
    //   const reservationList = response.filter((item) => item['status'] === -3);
    //   if (reservationList.length > 0) {
    //     this.overviewService.cancelInvestment(reservationList);
    //     this.overviewService.investrejectedEvent.subscribe(() => {
    //       this.initPage();
    //     });
    //   }
    // });
  }

  checkDocumentation() {
    this.profileService.getDocumentsType('SIGNATURE').subscribe(doc => {
      const list = doc.documents.filter((item) => item.subtype === 'INVEST' && item.projectId === this.id);
      if (list.length > 0 || this.secondaryDocsLits.length > 0) {
        if (list.length > 0) {
          const fList = { documents: list };
          fList.documents.forEach(element => {
            if (element.files !== null && element.files !== undefined) {
              element.files.forEach(invDoc => {
                if (invDoc.status === 'completed') {
                  this.investProjectDocuments = { documents: [element] };
                }
              });
            }
          });
        }
        // const el = {
        //   icon: 'paperclip',
        //   title: 'Docs',
        //   subtitle: 'Verás la documentación del proyecto',
        //   id: 'documentation',
        //   border: true
        // }
        // this.headerInfo.hasDocumentation = true;
        //this.pageList.push(el);
        this.chdRef.detectChanges();
      }
    });
  }

  checkPaymentCalendar() {
    const today = new Date();
    this.portfolioService.getNextBenefits().subscribe((resp: BenefitProject[]) => {
      resp.forEach(element => {
        if (element.projectId === this.id) {
          for (let i = 0; i < 12; i++) {
            let dateToSave = new Date(today.getFullYear(), today.getMonth() + i, today.getDay());
            let dateToSaveString = dateToSave.toLocaleString(this.translate.currentLang, { month: 'long', year: 'numeric' });
            this.benefitsByMonth.push(
              {
                date: [
                  dateToSave.getFullYear(),
                  dateToSave.getMonth() + 1,
                  dateToSave.getDay()
                ],
                dateName: `${dateToSaveString.charAt(0).toUpperCase() + dateToSaveString.slice(1)}`,
                benefits: []
              }
            );
          }

          const benefits: Benefit[] = [];
          if (element.benefits) {
            element.benefits.forEach(benefit => {
              benefits.push(benefit);
            });
          }

          benefits.forEach((benefit: Benefit) => {
            this.benefitsByMonth.forEach(month => {
              if (month.date[0] === benefit.date[0] && month.date[1] === benefit.date[1]) {
                month.benefits.push(
                  {
                    projectName: benefit.projectName,
                    amount: benefit.amount,
                    type: benefit.type,
                    paymentDescription: benefit.paymentDescription || null,
                    paymentStatus: benefit.paymentStatus || null,
                    paymentTitle: benefit.paymentTitle || null,
                    date: benefit.date,
                    sharePremiumOrRedemption: (benefit as any).share_premium_or_redemption,
                    profitOrInterest: (benefit as any).profit_or_interest
                  }
                );
              }
            })
          });
          this.benefitsByMonth = this.benefitsByMonth.filter((month) => month.benefits.length !== 0);
          this.chdRef.detectChanges();
        }
      });
    });
  }

  checkProduction(vip = false) {
    this.overviewService.getHasInvest(this.id).subscribe(() => {
      this.detailProjectService.getProjectPerformance(this.id).subscribe(resp => {
        this.productionHistoric = resp.production;
        this.moneyHistoric = resp.money;
        if (resp.lastUpdate && resp.lastUpdate !== undefined) {
          this.lastUpdate = this.getLastUpdate(resp.lastUpdate);
          this.listOfYears = this.getListYears(resp.firstUpdate, resp.lastUpdate);
          if (resp.money > 0 && resp.production > 0) {
            this.getGraphicsData();
            this.chdRef.detectChanges();
          }
        } else {
          this.checkedNoHasMonitoring = true;
        }
      });
    }, error => {
      if (vip) {
        this.detailProjectService.getProjectPerformance(this.id).subscribe(resp => {
          this.productionHistoric = resp.production;
          this.moneyHistoric = resp.money;
          if (resp.lastUpdate && resp.lastUpdate !== undefined) {
            this.lastUpdate = this.getLastUpdate(resp.lastUpdate);
            this.listOfYears = this.getListYears(resp.firstUpdate, resp.lastUpdate);
            if (resp.money > 0 && resp.production > 0) {
              this.getGraphicsData();
              this.chdRef.detectChanges();
            }
          } else {
            this.checkedNoHasMonitoring = true;
          }
        });
      } else {
        this.checkedNoHasMonitoring = true;
      }
    });
  }

  checkMeetingList() {
    this.strapiService.getCensusDetailForUser().subscribe(resp => {
      const data = resp;
      let meetingsArray: any[] = [];
      data.censuses.forEach(census => {
        if (census.meeting && census.meeting.status !== 'oculta' && census.meeting.project && census.meeting.project.id === this.id) {
          meetingsArray.push(census.meeting);
        }
      });

      if (meetingsArray.length > 0) {
        this.meetingList = meetingsArray;
        // const el = {
        //   icon: 'coin-stack',
        //   title: 'Juntas',//this.translate.instant('OVERVIEW.PAY'),
        //   subtitle: 'Juntas',//this.translate.instant('OVERVIEW.VIEW_PAY'),
        //   id: 'meeting',
        //   border: true
        // }
        // this.pageList.push(el);
        // this.headerInfo.hasMeetingList = true;
      }
    });
  }

  getLastUpdate(lastUpdate) {
    let endDateN;
    let todayN;
    let hour;

    endDateN = new Date(this.convertToIos(momentNs(lastUpdate).format('YYYY-MM-DD') + ' 00:00:00')).getTime();
    todayN = new Date(this.convertToIos(momentNs().format('YYYY-MM-DD') + ' 00:00:00')).getTime();

    const lessHourTxt = this.translate.instant('UPDATES.LESS_THAN_ONE_HOUR');
    const anHourTxt = this.translate.instant('UPDATES.ONE_HOUR_AGO');
    const h = (new Date().getTime() - new Date(lastUpdate).getTime()) / (1000 * 60 * 60);
    const minuts = Math.round(h * 60);

    if (h < 1) {
      hour = lessHourTxt;
    } else {
      if (h > 1 && h < 2) {
        hour = anHourTxt;
      } else {
        hour = this.translate.instant('UPDATES.HOURS_AGO', { time: Math.round(h) });
      }
    }

    if (endDateN === isNaN || endDateN === undefined || !endDateN) {
      endDateN = new Date(
        this.convertToIos(momentNs(lastUpdate.replace('/', '-').replace('/', '-')).format('YYYY-MM-DD') + ' 00:00:00')
      ).getTime();
    }

    const timeLeft = (todayN - endDateN) / (1000 * 60 * 60 * 24);
    const lastUpdateMoment = this.translate.instant('UPDATES.LAST_UPDATE');
    const lastUpdateM = this.translate.instant('UPDATES.LAST_UPDATE_MINUTS_AGO', { min: minuts });
    const lastUpdateH = this.translate.instant('UPDATES.LAST_UPDATE_HOURS', { hours: hour });
    const lastUpdateD = this.translate.instant('UPDATES.LAST_UPDATE_DAY_AGO');
    const lastUpdateT = this.translate.instant('UPDATES.LAST_UPDATE_DAYS_AGO', { days: Math.round(timeLeft) });

    switch (timeLeft) {
      case 0:
        if (minuts < 60) {
          if (minuts > 1) {
            this.lastUpdates = lastUpdateM;
          } else {
            this.lastUpdates = lastUpdateMoment;
          }
        } else {
          this.lastUpdates = lastUpdateH;
        }
        break;
      case 1:
        this.lastUpdates = lastUpdateD;
        break;
      default:
        this.lastUpdates = lastUpdateT;
        break;
    }
    return timeLeft;
  }

  getListYears(dataIni, dateFin) {
    let endDateN;
    let startDateN;
    let arrayYears = [];

    startDateN = new Date(this.convertToIos(momentNs(dataIni).format('YYYY-MM-DD') + ' 00:00:00')).getFullYear();
    endDateN = new Date(this.convertToIos(momentNs(dateFin).format('YYYY-MM-DD') + ' 00:00:00')).getFullYear();
    for (let i = startDateN; i <= endDateN; i++) {
      arrayYears.push({
        'label': i,
        'value': i
      });
    }
    return arrayYears;
  }

  onClickYearPicker(year) {
    this.startDate = year + '-01-01';
    this.endDate = year + '-12-31';
    this.getGraphicsData();
    this.chdRef.detectChanges();
  }

  getGraphicsData() {
    const startDate = this.startDate;
    const endDate = this.endDate;
    this.currentMonth = this.parseCurrentMonth(startDate);
    this.currentYear = this.parseCurrentYear(startDate);
    this.currentDate = this.currentYear;

    // Hacemos llamada al N8N que tiene los datos buenos de monitorización
    this.dailyProductionservice.getApiMonitoringDailyData(this.id, startDate, endDate).subscribe(resp => {
      this.parseDailyData(resp);
    }, error => {
      // Repetimos llamada si falla ya que a veces la primera es bloqueada por el antivirus
      setTimeout(() => {
        this.dailyProductionservice.getApiMonitoringDailyData(this.id, startDate, endDate).subscribe(response => {
          this.parseDailyData(response);
        }, error => {
          this.hasDailyProductionList = false;
          this.productionListChecked = true;

          this.loadedDailyIncomeList = false;
          this.chdRef.detectChanges();
        });
      }, 400);
    });
  }

  parseDate(fecha: any): string {
    const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
    let [ano, mes, dia] = [null, null, null];
    // Dividir la fecha en año, mes y día
    if (fecha instanceof Array) {
      [ano, mes, dia] = fecha;
    } else {
      [ano, mes, dia] = fecha.split('-');
    }

    // Crear un nuevo objeto de fecha con los componentes extraídos
    const fechaObj = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));

    // Obtener los componentes de la nueva fecha
    const nuevoDia = fechaObj.getDate();
    const nuevoMes = fechaObj.getMonth(); // Nota: los meses comienzan desde 0
    const nuevoAno = fechaObj.getFullYear(); // Obtener solo los últimos dos dígitos del año

    // Formatear los componentes en el formato deseado
    // const formatoDeseado = `${nuevoDia.toString().padStart(2, '0')}/${nuevoMes.toString().padStart(2, '0')}/${nuevoAno.toString()}`;
    const formatoDeseado = `${nuevoDia} ${months[nuevoMes]}`;

    return formatoDeseado;
  }

  parseCurrentMonth(fecha: any): string {
    const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
    let [ano, mes, dia] = [null, null, null];
    // Dividir la fecha en año, mes y día
    if (fecha instanceof Array) {
      [ano, mes, dia] = fecha;
    } else {
      [ano, mes, dia] = fecha.split('-');
    }
    // Crear un nuevo objeto de fecha con los componentes extraídos
    const fechaObj = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));

    // Obtener los componentes de la nueva fecha
    const nuevoMes = fechaObj.getMonth(); // Nota: los meses comienzan desde 0

    // Formatear los componentes en el formato deseado
    const formatoDeseado = `${months[nuevoMes]}`;

    return formatoDeseado;
  }

  parseCurrentYear(fecha: any): string {
    let [ano, mes, dia] = [null, null, null];
    // Dividir la fecha en año, mes y día
    if (fecha instanceof Array) {
      [ano, mes, dia] = fecha;
    } else {
      [ano, mes, dia] = fecha.split('-');
    }

    // Crear un nuevo objeto de fecha con los componentes extraídos
    const fechaObj = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));

    // Obtener los componentes de la nueva fecha
    const nuevoAno = fechaObj.getFullYear(); // Obtener solo los últimos dos dígitos del año

    // Formatear los componentes en el formato deseado
    const formatoDeseado = `${nuevoAno.toString()}`;

    return formatoDeseado;
  }

  parseDailyData(data) {
    const datosAgrupados = data;

    if (datosAgrupados) {

      let modelAgrupados = [];
      let modelIncomesAgrupados = [];
      let modelAnnual = [];
      let modelIncomesAnnual = [];

      let totalIngresosReales = 0;
      let totalIngresosEstimados = 0;
      let totalProduccionReal = 0;
      let totalProduccionEstimada = 0;
      let month = this.currentMonth;

      let produccionRealAgrupada = 0;
      let produccionEstimadaAgrupada = 0;
      let ingresosRealesAgrupados = 0;
      let ingresosEstimadosAgrupados = 0;
      let produccionRealMensual = 0;
      let produccionEstimadaMensual = 0;
      let ingresosRealesMensuales = 0;
      let ingresosEstimadosMensuales = 0;

      for (let k = 0; k < datosAgrupados.length; k++) {
        let model = [];
        let modelIncomes = [];
        let date = this.parseDate(datosAgrupados[k].date);
        let dataMonth = datosAgrupados[k].estimationMonth;
        let dataDaily = datosAgrupados[k].diary;
        let projectId = datosAgrupados[k].projectId;
        let currentMonth = this.parseCurrentMonth(datosAgrupados[k].date);

        if (month != currentMonth) { // Detectamos que cambiamos de mes, almacenamos e inicializamos
          modelAnnual.push({
            label: month,
            category: month,
            data: produccionRealMensual.toFixed(0),
            data_estimate: produccionEstimadaMensual.toFixed(0),
            data_days: modelAgrupados,
          });
          modelIncomesAnnual.push({
            label: month,
            category: month,
            data: (ingresosRealesMensuales < 100) ? ingresosRealesMensuales.toFixed(1) : ingresosRealesMensuales.toFixed(0),
            data_estimate: (ingresosEstimadosMensuales < 100) ? ingresosEstimadosMensuales.toFixed(1) : ingresosEstimadosMensuales.toFixed(0),
            data_days: modelIncomesAgrupados
          });
          month = currentMonth;

          // Inicializamos para el siguiente mes
          produccionRealMensual = 0;
          produccionEstimadaMensual = 0;
          ingresosRealesMensuales = 0;
          ingresosEstimadosMensuales = 0;

          // Total ingresos estimados NEW
          totalIngresosEstimados = totalIngresosEstimados + (dataMonth.production * (parseFloat(dataMonth.priceMwh) || 0)); // Volcamos el que viene del business plan

          modelAgrupados = [];
          modelIncomesAgrupados = [];
        }

        // Total ingresos estimados NEW 1a
        if (totalIngresosEstimados == 0) {
          totalIngresosEstimados = totalIngresosEstimados + (dataMonth.production * (parseFloat(dataMonth.priceMwh) || 0)); // Volcamos el que viene del business plan
        }

        for (let i = 0; i < dataDaily.length; i++) {
          // if((dataDaily[i].time < 8) || (dataDaily[i].time > 18)) { continue; }
          let prod = parseFloat(dataDaily[i].production) || 0;
          let prodEstimated = parseFloat(dataMonth.production) || 0;
          let bp = parseFloat(dataMonth.priceMwh) || 0;
          let watts = parseFloat(dataDaily[i].wattHours) / 1000;
          let pool = parseFloat(dataDaily[i].pricePool) || 0;
          let hour = parseInt(dataDaily[i].time);

          let produccionReal = prod;
          let produccionEstimada = watts;
          let ingresosReales = (prod * bp) / 1000;
          if ((projectId == 23) || (projectId == 24)) {
            ingresosReales = (prod * pool) / 1000;
          }
          let ingresosEstimados = (watts * bp) / 1000;

          produccionRealAgrupada = produccionRealAgrupada + produccionReal;
          produccionEstimadaAgrupada = produccionEstimadaAgrupada + produccionEstimada;
          ingresosRealesAgrupados = ingresosRealesAgrupados + ingresosReales;
          ingresosEstimadosAgrupados = ingresosEstimadosAgrupados + ingresosEstimados;

          produccionRealMensual = produccionRealMensual + produccionReal;
          // produccionEstimadaMensual = produccionEstimadaMensual + produccionEstimada;
          produccionEstimadaMensual = dataMonth.production * 1000; // Volcamos el que viene del business plan
          ingresosRealesMensuales = ingresosRealesMensuales + ingresosReales;
          // ingresosEstimadosMensuales = ingresosEstimadosMensuales + ingresosEstimados;
          ingresosEstimadosMensuales = prodEstimated * bp;

          model.push({
            label: hour + 'h',
            category: hour,
            data: produccionReal.toFixed(0),
            data_estimate: produccionEstimada.toFixed(0)
          });
          modelIncomes.push({
            label: hour + 'h',
            category: hour,
            data: (ingresosReales < 100) ? ingresosReales.toFixed(1) : ingresosReales.toFixed(0),
            data_estimate: (ingresosEstimados < 100) ? ingresosEstimados.toFixed(1) : ingresosEstimados.toFixed(0)
          });

        }

        modelAgrupados.push({
          label: date,
          category: date,
          data: produccionRealAgrupada.toFixed(0),
          data_estimate: produccionEstimadaAgrupada.toFixed(0),
          data_hours: model,
        });
        modelIncomesAgrupados.push({
          label: date,
          category: date,
          data: (ingresosRealesAgrupados < 100) ? ingresosRealesAgrupados.toFixed(1) : ingresosRealesAgrupados.toFixed(0),
          data_estimate: (ingresosEstimadosAgrupados < 100) ? ingresosEstimadosAgrupados.toFixed(1) : ingresosEstimadosAgrupados.toFixed(0),
          data_hours: modelIncomes
        });

        totalIngresosReales = totalIngresosReales + ingresosRealesAgrupados;
        // totalIngresosEstimados = totalIngresosEstimados + ingresosEstimadosAgrupados;
        totalProduccionReal = totalProduccionReal + produccionRealAgrupada;
        totalProduccionEstimada = totalProduccionEstimada + produccionEstimadaAgrupada;

        // Inicializamos para el siguiente dia
        produccionRealAgrupada = 0;
        produccionEstimadaAgrupada = 0;
        ingresosRealesAgrupados = 0;
        ingresosEstimadosAgrupados = 0;

        // Total ingresos estimados NEW Last
        if (k == (datosAgrupados.length - 1)) {
          totalIngresosEstimados = totalIngresosEstimados + (dataMonth.production * (parseFloat(dataMonth.priceMwh) || 0)); // Volcamos el que viene del business plan
        }
      }

      // Guardamos el último dato recogido
      modelAnnual.push({
        // label: 'Producción mensual (' + month + ')',
        label: month,
        category: month,
        data: produccionRealMensual.toFixed(0),
        data_estimate: produccionEstimadaMensual.toFixed(0),
        data_days: modelAgrupados,
      });
      modelIncomesAnnual.push({
        // label: 'Ingresos mensuales (' + month + ')',
        label: month,
        category: month,
        data: (ingresosRealesMensuales < 100) ? ingresosRealesMensuales.toFixed(1) : ingresosRealesMensuales.toFixed(0),
        data_estimate: (ingresosEstimadosMensuales < 100) ? ingresosEstimadosMensuales.toFixed(1) : ingresosEstimadosMensuales.toFixed(0),
        data_days: modelIncomesAgrupados
      });

      this.moneyToday = (totalIngresosReales < 100) ? totalIngresosReales.toFixed(1) : totalIngresosReales.toFixed(0);
      this.moneyEstimated = (totalIngresosEstimados < 100) ? totalIngresosEstimados.toFixed(1) : totalIngresosEstimados.toFixed(0);
      this.productionToday = totalProduccionReal.toFixed(0);
      this.productionEstimated = totalProduccionEstimada.toFixed(0);

      this.dailyProductionList = modelAnnual;
      this.hasDailyProductionList = true;
      this.productionListChecked = true;

      this.dailyIncomeList = modelIncomesAnnual;
      this.loadedDailyIncomeList = true;
    } else {
      this.hasDailyProductionList = false;
      this.productionListChecked = true;

      this.loadedDailyIncomeList = false;
    }
    this.chdRef.detectChanges();
  }

  openHelpGrid(level, index) {
    this.helpService.openHelp(level, index, 'DASHBOARD_DETAIL');
  }

  convertToIos(date) {
    const arr = date.split(/[- :]/);
    const r = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    return r;
  }

  closeModal() {
    this.closeModalEvent.emit();
    try {
      this.modalController.dismiss();
    } catch { }
  }

  scrollToCalculateBeneffits() {
    const el = document.getElementById("content");
    el.scrollTo({
      top: this.calculatorComponet.nativeElement.offsetTop,
      behavior: 'smooth',
    })
  }

  stayInformed() {
    const params = {
      projectName: this.detailProject.name,
      projectId: this.detailProject.id
    }
    this.modalService.showModal(SubscribeProjectNewsComponent, params, '').subscribe((modal: any) => {
      modal.getChildComponent().subscribe((componentRef: SubscribeProjectNewsComponent) => {
        componentRef.chageStageHubSpotEvent.subscribe(val => {
          this.changeHuspotStage(val);
          componentRef.formSubmited(true);
          //this.modalService.removeModal();
        });
      })
    });
  }

  changeHuspotStage(stage, params: any = {}) {
    const posthogEventMap: Record<string, string> = {
      'checkout': 'investment_open_modal_checkout',
      'add_to_cart': 'investment_click_button',
      'payment': 'payment_start_flow',
      'sign': 'investment_submit_form_modal',
      'preinvestment': 'investment_open_modal_confirm',
      'ok': 'investment_success_modal_shown',
      'reservation': 'investment_submit_reservation',
      'investmentIntention': 'investment_submit_intention',
      'cancel': 'investment_cancel',
      'cancel_pre_investment': 'investment_cancel_preinvestment',
      'validation': 'investment_submit_validation',
      'test': 'investment_open_modal_test',
    };
    this.storage.get('USERNAME').then((val) => {
      const userEmail = val;
      const idProject = this.detailProject.id;
      const nameProject = this.detailProject.name;
      let currentDeal;
      let trackParams = {
        project_status: this.detailProject.status,
        project_id: idProject,
        project_name: this.detailProject.name,
        amount: this.utilsService.checkEmptyField(params['amount']) ? '-' : Number(params['amount'])
      };

      // Completamos otros parametros
      if (stage === 'cancel' || stage === 'cancel_pre_investment') {
        params = {};
        (trackParams as any)['invest_id'] = this.investId;
      } else {
        params['legible'] = (this.detailProject.allowedInvestWithThisPostalCode) ? true : false;
        params['proyecto_por_fases'] = (this.detailProject.investment_by_postal_code_enabled) ? true : false;
        params['fase_del_proyecto'] = (this.detailProject.investment_by_postal_code_enabled) ? this.getCurrentStep() : '';
        params['estado_del_proyecto'] = this.detailProject.status;
      }

      if (
        this.detailProject.status === 3
        || this.detailProject.status === 4
        || this.detailProject.status === 12
        || this.detailProject.status === 15
      ) { // Solo actualiza si está abierto a inversion, reservas o proximamente
        if (this.projectDeal === undefined && !this.updatingDeal) {

          this.updatingDeal = true;
          this.HubspotService.getDeals(userEmail, idProject).subscribe((resHusbpot: any) => {
            if (resHusbpot.success) {
              const deals = resHusbpot.data.results;
              if (deals.length && (this.canChangeStage || stage === 'cancel' || stage === 'cancel_pre_investment')) {
                currentDeal = deals[0].id;
                if (stage !== '' && stage !== undefined
                  && this.HubspotService.canTransitionStage(deals[0].properties.dealstage, stage)
                  && ((deals[0].properties.dealstage !== this.HubspotService.getStage('ok')
                    && deals[0].properties.dealstage !== this.HubspotService.getStage('reservation')
                    && deals[0].properties.dealstage !== this.HubspotService.getStage('validation')
                    && deals[0].properties.dealstage !== this.HubspotService.getStage('preinvestment')
                    && this.isHubspodDealOkInCurrentInvest !== true)
                    || stage === 'cancel'
                    || stage === 'cancel_pre_investment')
                ) {
                  this.HubspotService.updateDeal(currentDeal, stage, params).subscribe((resHusbpot: any) => {
                    this.projectDeal = resHusbpot.data;
                    this.updatingDeal = false;
                  }, () => { this.updatingDeal = false; });
                  if (stage !== 'download') { // No enviar evento de descarga porque ya se hace en otra funcion independiente del estado
                    this.posthogService.pushEventParams(posthogEventMap[stage] || stage, params);
                    if (stage !== 'add_to_cart') { // ya se manda como pushEcomEventGTM('add_to_cart', ...)
                      this.dataLayerService.pushCustomEventGTM(posthogEventMap[stage] || stage);
                    }
                  }
                }
              } else if (this.canChangeStage) {
                if (this.createdDealThisSession) {
                  //console.log('[HubSpot] changeHubspotStage → deal ya creado en esta sesión (ID:', this.createdDealThisSession, '), evitando duplicado. stage:', stage);
                  if (stage !== '' && stage !== undefined) {
                    this.HubspotService.updateDeal(this.createdDealThisSession, stage, params).subscribe((resHusbpot: any) => {
                      this.projectDeal = resHusbpot.data;
                      this.updatingDeal = false;
                    }, () => { this.updatingDeal = false; });
                  } else {
                    this.updatingDeal = false;
                  }
                } else {
                  this.updatingDeal = true;
                  this.storage.get('HS_SURNAME_USER').then((name) => {
                    const userName = name;
                    this.storage.get('HS_CONTACT_ID').then((idhbp) => {
                      //console.log('[HubSpot] createDeal PRE → HS_CONTACT_ID:', idhbp, '| userEmail (referencias):', userEmail, '| userName:', userName);
                      const paramsCreate = {
                        "dealname": `${userName} - ${nameProject}`,
                        "referencias": userEmail,
                        "nombre_del_proyecto": nameProject,
                        "project": idProject,
                        "fase_del_proyecto": params['fase_del_proyecto'],
                        "legible": params['legible'],
                        "estado_del_proyecto": params['estado_del_proyecto'],
                        "proyecto_por_fases": params['proyecto_por_fases']
                      };
                      this.HubspotService.createDeal(idhbp, paramsCreate).subscribe((resHusbpot: any) => {
                        if (resHusbpot.success) {
                          currentDeal = resHusbpot.data.id;
                          this.createdDealThisSession = currentDeal;
                          //console.log('[HubSpot] createDeal → deal guardado localmente. ID:', this.createdDealThisSession);
                          if (stage !== '' && stage !== undefined) {
                            this.HubspotService.updateDeal(currentDeal, stage, params).subscribe((resHusbpot: any) => {
                              this.projectDeal = resHusbpot.data;
                              this.updatingDeal = false;
                            }, () => { this.updatingDeal = false; });
                          }
                        }
                      });
                    });
                  });
                }
              }
            }
          });
          if (stage !== 'download') {
            this.posthogService.pushEventParams(posthogEventMap[stage] || stage, trackParams);
            if (stage !== 'add_to_cart') { // ya se manda como pushEcomEventGTM('add_to_cart', ...)
              this.dataLayerService.pushCustomEventGTM(posthogEventMap[stage] || stage);
            }
          }
        } else {
          if (stage !== '' && stage !== undefined
            && (this.canChangeStage || stage === 'cancel' || stage === 'cancel_pre_investment')
            && (!this.updatingDeal || stage === 'cancel' || stage === 'cancel_pre_investment')
            && this.HubspotService.canTransitionStage(this.projectDeal.properties.dealstage, stage)
            && ((this.projectDeal.properties.dealstage !== this.HubspotService.getStage('ok')
              && this.projectDeal.properties.dealstage !== this.HubspotService.getStage('reservation')
              && this.projectDeal.properties.dealstage !== this.HubspotService.getStage('preinvestment')
              && this.isHubspodDealOkInCurrentInvest !== true)
              || stage === 'cancel'
              || stage === 'cancel_pre_investment')
          ) {
            this.updatingDeal = true;
            this.HubspotService.updateDeal(this.projectDeal.id, stage, params).subscribe((resHusbpot: any) => {
              this.projectDeal = resHusbpot.data;
              this.updatingDeal = false;
            }, () => { this.updatingDeal = false; });
          }
          if (stage !== 'download') {
            this.posthogService.pushEventParams(posthogEventMap[stage] || stage, trackParams);
            if (stage !== 'add_to_cart') { // ya se manda como pushEcomEventGTM('add_to_cart', ...)
              this.dataLayerService.pushCustomEventGTM(posthogEventMap[stage] || stage);
            }
          }
        }
      }
    });
  }

  renewSession(action: any) {
    this.refreshModalOpened = true;
    this.biometricService.checkBiometricAvailable();
    let biometricLoginFailed = false;
    let biometricUsername: string = null;
    const modalParams = {};
    this.alertService.showModal(RenewSessionComponent, modalParams, '', '', true).subscribe((modal: any) => {
      modal.getChildComponent().subscribe((componentRef: RenewSessionComponent) => {
        componentRef.cancelEvent.subscribe((res) => {
          this.alertService.removeModal();
          this.refreshModalOpened = false;
        });
        componentRef.aceptEvent.subscribe((res) => {
          this.storage.get('USERNAME').then(async (val) => {
            const email = biometricUsername || val;
            const params = { email, password: res };
            const isLoginCorrect = await this.authService.login(params);
            if (isLoginCorrect) {
              if (biometricLoginFailed) {
                this.biometricService.askToUpdateCredentials(email, res);
              }
              this.alertService.removeModal();
              this.refreshModalOpened = false;
              //this.isRefreshLoginOk(action);
            } else {
              componentRef.passwordError();
            }
          });
        });
        this.biometricService.getCredentialsEvent.subscribe(credentials => {
          if (credentials !== null) {
            const params = {
              email: credentials.username,
              password: credentials.password,
            };
            this.authService.login(params).then(isLoginCorrect => {
              if (isLoginCorrect) {
                this.alertService.removeModal();
                this.refreshModalOpened = false;
                //this.isRefreshLoginOk(action);
              } else {
                biometricLoginFailed = true;
                biometricUsername = credentials.username;
                componentRef.biometricError();
              }
            });
          } else {
            biometricLoginFailed = true;
            componentRef.biometricError();
          }
        });
      });
      modal.onClose().subscribe();
    });
  }

  scrollToContent() {
    const el = document.getElementById("content");
    el.scrollTo({
      top: 360,
      behavior: 'smooth',
    })
  }

  changeDataToAssociatedProjectInfo() {
    this.detailProject['profitability'] = this.associatedProjectData['profitability'];
    this.detailProject['locale'] = this.associatedProjectData['locale'];
    this.statusAside['profitability'] = this.associatedProjectData['profitability'];
    this.isLoaded = false;
    this.associatedDataShowed = true;
    //this.detailProject[]
    this.getAboutProjectInfo(this.detailProject);
    setTimeout(() => {
      this.isLoaded = true;
    }, 200);
    // associatedProjectData
  }
}
